/* eslint-disable */
// biome-ignore-all assist/source/organizeImports: this is generated code
import { OperationContext } from 'urql';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Time: { input: string; output: string };
};

export enum AIDescriptionStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
}

export type AddUserToTeam = {
  teamID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export enum AggregationType {
  COUNT = 'COUNT',
  COUNT_SAMPLES = 'COUNT_SAMPLES',
  HISTOGRAM = 'HISTOGRAM',
  LAST = 'LAST',
  MAX = 'MAX',
  MEAN = 'MEAN',
  MEDIAN = 'MEDIAN',
  MIN = 'MIN',
  P10 = 'P10',
  P20 = 'P20',
  P25 = 'P25',
  P30 = 'P30',
  P40 = 'P40',
  P50 = 'P50',
  P60 = 'P60',
  P70 = 'P70',
  P75 = 'P75',
  P80 = 'P80',
  P90 = 'P90',
  P95 = 'P95',
  P99 = 'P99',
  P999 = 'P999',
  P9999 = 'P9999',
  STDEV = 'STDEV',
  SUM = 'SUM',
  SUMSQ = 'SUMSQ',
  TYPE_INVALID = 'TYPE_INVALID',
}

/** AlertAnalysisAggregationDimensionType specifies the type of dimension being aggregated. */
export enum AlertAnalysisAggregationDimensionType {
  /** Monitor label key-value pairs. */
  MONITOR_LABEL = 'MONITOR_LABEL',
  /** Monitor metadata (e.g., monitor_slug). */
  MONITOR_METADATA = 'MONITOR_METADATA',
  /** Alert signal key-value pairs. */
  SIGNAL = 'SIGNAL',
}

/** AlertAnalysisAggregationOptionsInput contains options for how to perform alert aggregation. */
export type AlertAnalysisAggregationOptionsInput = {
  /** If true, aggregate data over time buckets. */
  enableTimeBucketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include monitor_slug as an additional grouping dimension. */
  includeMonitorDimension?: InputMaybe<Scalars['Boolean']['input']>;
  /** Duration of each time bucket (e.g., "15m", "1h", "6h"). Required if enableTimeBucketing is true. */
  timeBucketDuration?: InputMaybe<Scalars['String']['input']>;
};

/** AlertAnalysisLabelMatcherInput defines matching operations for a specific label. */
export type AlertAnalysisLabelMatcherInput = {
  /** The label key to match. */
  key: Scalars['String']['input'];
  /** String matcher for the label value. */
  value: AlertAnalysisStringMatcherInput;
};

/** AlertAnalysisLabelsMatcherInput defines label matching operations for filtering. */
export type AlertAnalysisLabelsMatcherInput = {
  /** Label matchers to apply. */
  labels: Array<AlertAnalysisLabelMatcherInput>;
  /** Minimum number of label matches required for this matcher to be satisfied. */
  minMatches?: InputMaybe<Scalars['Int']['input']>;
};

/** AlertAnalysisStringMatcherInput defines string matching operations for filtering. */
export type AlertAnalysisStringMatcherInput = {
  /** Multiple values for operations like ANY_OF, NONE_OF. */
  multiValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The string matching operation to perform. */
  operation: AlertAnalysisStringMatcherOperation;
  /** Single value for operations like EQUAL, NOT_EQUAL, CONTAINS, etc. */
  singleValue?: InputMaybe<Scalars['String']['input']>;
};

/** AlertAnalysisStringMatcherOperation defines the available string matching operations. */
export enum AlertAnalysisStringMatcherOperation {
  /** Matches any of the provided values. */
  ANY_OF = 'ANY_OF',
  /** Contains substring match. */
  CONTAINS = 'CONTAINS',
  /** Exact equality match. */
  EQUAL = 'EQUAL',
  /** Does not match any of the provided values. */
  NONE_OF = 'NONE_OF',
  /** Does not contain substring match. */
  NOT_CONTAINS = 'NOT_CONTAINS',
  /** Not equal match. */
  NOT_EQUAL = 'NOT_EQUAL',
  /** Negated regular expression match. */
  NOT_REGEX_EQUAL = 'NOT_REGEX_EQUAL',
  /** Regular expression match. */
  REGEX_EQUAL = 'REGEX_EQUAL',
}

/** AlertDatastoreSeverity represents the severity level of an alert. */
export enum AlertDatastoreSeverity {
  /** Critical level alert */
  CRITICAL = 'CRITICAL',
  UNKNOWN = 'UNKNOWN',
  /** Warning level alert */
  WARN = 'WARN',
}

/** AlertDatastoreStatus represents the current status of an alert in the datastore. */
export enum AlertDatastoreStatus {
  /** Alert has been resolved */
  RESOLVED = 'RESOLVED',
  /** Alert is currently triggered */
  TRIGGERED = 'TRIGGERED',
  UNKNOWN = 'UNKNOWN',
}

export enum AlertEventType {
  MONITOR_MUTED = 'MONITOR_MUTED',
  MONITOR_RESOLVED = 'MONITOR_RESOLVED',
  MONITOR_RESOLVED_NOTIFICATION_FAILED_TO_SEND = 'MONITOR_RESOLVED_NOTIFICATION_FAILED_TO_SEND',
  MONITOR_RESOLVED_NOTIFICATION_SENT = 'MONITOR_RESOLVED_NOTIFICATION_SENT',
  MONITOR_TRIGGERED = 'MONITOR_TRIGGERED',
  MONITOR_TRIGGERED_NOTIFICATION_FAILED_TO_SEND = 'MONITOR_TRIGGERED_NOTIFICATION_FAILED_TO_SEND',
  MONITOR_TRIGGERED_NOTIFICATION_SENT = 'MONITOR_TRIGGERED_NOTIFICATION_SENT',
  MONITOR_UNMUTED = 'MONITOR_UNMUTED',
  UNKNOWN = 'UNKNOWN',
}

/** AlertFiltersCombineMode specifies how multiple alert filters are combined. */
export enum AlertFiltersCombineMode {
  /** All filters must match (default). */
  AND = 'AND',
  /** At least one filter must match. */
  OR = 'OR',
}

export enum AlertRouteMatcherType {
  EXACT_MATCHER_TYPE = 'EXACT_MATCHER_TYPE',
  REGEXP_MATCHER_TYPE = 'REGEXP_MATCHER_TYPE',
}

export enum AlertState {
  CRITICAL = 'CRITICAL',
  DOWNTIMED = 'DOWNTIMED',
  FIRING = 'FIRING',
  INACTIVE = 'INACTIVE',
  NODATA = 'NODATA',
  PASS = 'PASS',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING',
}

/**
 * AlertsFilters contains filtering options for querying alerts.
 * All filters are ANDed together when multiple are specified.
 */
export type AlertsFilters = {
  /** Filter by collection reference. */
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  /** Filter by config entity name (searches both monitor and SLO names) */
  configEntityName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter alerts by time window. Returns alerts that were active/triggered at any time during the window.
   * This includes alerts whose created_at is within the time window OR whose resolved_at is within the time window.
   */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether alerts have resolution notes */
  hasResolutionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by monitor slug */
  monitorSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by whether the alert is currently muted. If this is unspecified, all alerts are returned. */
  mutedStates?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by alert severity. If multiple severities are provided, they are ORed together */
  severities?: InputMaybe<Array<AlertDatastoreSeverity>>;
  /** Filter by signal labels. Only alerts with signals containing all specified labels are returned (subset match). */
  signalLabels?: InputMaybe<Array<LabelInput>>;
  /** Filter by signal labels that must NOT match. Alerts with signals matching any of these labels are excluded. */
  signalNotEqualLabels?: InputMaybe<Array<LabelInput>>;
  /** Filter by SLO slug */
  sloSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter alerts by time window. Returns alerts that were active/triggered at any time during the window.
   * This includes alerts whose created_at is within the time window OR whose resolved_at is within the time window.
   */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** Filter by alert status. If multiple statuses are provided, they are ORed together */
  statuses?: InputMaybe<Array<AlertDatastoreStatus>>;
  /** Filter by team slug */
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AllDashboardsFilter = {
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclude grafana dashboards that have been migrated to a native dashboard */
  excludeMigratedGrafana?: InputMaybe<Scalars['Boolean']['input']>;
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, search for dashboards that are owned by the filtered collections as well as
   * those linked to the filtered collections.
   */
  includeLinkedCollections?: InputMaybe<Scalars['Boolean']['input']>;
  includePopularity?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<LabelInput>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, only dashboards that are in the customer namespace will be returned. */
  onlyCustomerManaged?: InputMaybe<Scalars['Boolean']['input']>;
  ordering?: InputMaybe<DashboardOrdering>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, only dashboards owned by this source will be included */
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnalyticsEventInput = {
  eventId: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  eventTime: Scalars['Time']['input'];
  eventType: Scalars['String']['input'];
  pageData?: InputMaybe<PageDataInput>;
  sessionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** AnalyzeAlertsAggregateInput contains the parameters for the analyzeAlertsAggregate query. */
export type AnalyzeAlertsAggregateInput = {
  /** Aggregation options controlling how alerts are grouped and counted. */
  aggregationOptions?: InputMaybe<AlertAnalysisAggregationOptionsInput>;
  /** Optional filtering options for the aggregation query. Deprecated - use filters and filtersCombineMode instead. */
  filter?: InputMaybe<AnalyzeAlertsListFilterInput>;
  /** Multiple filters for more flexible filtering. When provided, filter field is ignored. */
  filters?: InputMaybe<Array<AnalyzeAlertsListFilterInput>>;
  /** How to combine multiple filters. Defaults to AND if not specified. */
  filtersCombineMode?: InputMaybe<AlertFiltersCombineMode>;
  /** Time range for the query. Both startTime and endTime are required in RFC3339 format. */
  timeRange: NewTimeRange;
};

/**
 * AnalyzeAlertsListFilterInput contains comprehensive filter options for the list alerts query.
 * This uses enhanced filtering capabilities with string matchers and label matchers.
 */
export type AnalyzeAlertsListFilterInput = {
  /** Filter by mute status. When true, only returns muted alerts. When false, only returns non-muted alerts. */
  isMuted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by maximum duration in seconds. Only returns alerts with duration less than or equal to this value. */
  maxDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by minimum duration in seconds. Only returns alerts with duration greater than or equal to this value. */
  minDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by monitor labels using label matching operations. */
  monitorLabels?: InputMaybe<AlertAnalysisLabelsMatcherInput>;
  /** Filter by monitor slug using string matching operations. */
  monitorSlug?: InputMaybe<AlertAnalysisStringMatcherInput>;
  /** Filter by notification policy slug using string matching operations. */
  notificationPolicySlug?: InputMaybe<AlertAnalysisStringMatcherInput>;
  /** Filter by signal labels using label matching operations. */
  signals?: InputMaybe<AlertAnalysisLabelsMatcherInput>;
};

/** AnalyzeAlertsListInput contains the parameters for the analyzeAlertsList query. */
export type AnalyzeAlertsListInput = {
  /** Optional filtering options for the list alerts query. Deprecated - use filters and filtersCombineMode instead. */
  filter?: InputMaybe<AnalyzeAlertsListFilterInput>;
  /** Multiple filters for more flexible filtering. When provided, filter field is ignored. */
  filters?: InputMaybe<Array<AnalyzeAlertsListFilterInput>>;
  /** How to combine multiple filters. Defaults to AND if not specified. */
  filtersCombineMode?: InputMaybe<AlertFiltersCombineMode>;
  /** Time range for the query. Both startTime and endTime are required in RFC3339 format. */
  timeRange: NewTimeRange;
};

export type AnnotationInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AttributeFilterListInput = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  telemetryTypes?: InputMaybe<Array<TelemetryType>>;
};

export type BetweenTimeFilterInput = {
  maxTimestamp: Scalars['String']['input'];
  minTimestamp: Scalars['String']['input'];
};

export type BoolFilterInput = {
  value: Scalars['Boolean']['input'];
};

export type BulkCreateThreadInput = {
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetInput;
  /** Initial comment text for the thread */
  text: Scalars['String']['input'];
};

export type BulkCreateThreadsInput = {
  threads: Array<BulkCreateThreadInput>;
};

export type BulkUpdateTeam = {
  addedUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removedUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamID: Scalars['ID']['input'];
};

export type BulkUpdateTeamsForUser = {
  addedTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removedTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  userID: Scalars['ID']['input'];
};

export type CloseToTimeFilterInput = {
  timestamp: Scalars['String']['input'];
};

export type CollectionLinkDashboardRefInput = {
  slug: Scalars['String']['input'];
};

/** CollectionLinkEntityReference is a type that specifies a reference to an entity in a collection link. */
export type CollectionLinkEntityReferenceInput = {
  /** The slug of entity being referenced */
  slug: Scalars['String']['input'];
};

/**
 * CollectionLinkInput is an input type that specifies a collection link to create or update.
 * A collection link must reference either a monitor or a dashboard.
 * If a slug is not provided, a new collection link will be created.
 */
export type CollectionLinkInput = {
  collectionRef: CollectionRef;
  dashboardRef?: InputMaybe<CollectionLinkDashboardRefInput>;
  monitorRef?: InputMaybe<CollectionLinkMonitorRefInput>;
};

/** CollectionLinkListFilterInput is an input type that specifies filter criteria for listing collection links. */
export type CollectionLinkListFilterInput = {
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  dashboardRefs?: InputMaybe<Array<CollectionLinkEntityReferenceInput>>;
  monitorRefs?: InputMaybe<Array<CollectionLinkEntityReferenceInput>>;
  types?: InputMaybe<Array<CollectionLinkType>>;
};

export type CollectionLinkMonitorRefInput = {
  impactsServiceHealth: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};

/** CollectionLinkType is an enum that represents the type of entity that a collection link references. */
export enum CollectionLinkType {
  DASHBOARD = 'DASHBOARD',
  MONITOR = 'MONITOR',
}

/** CollectionRef is used to querying for collections or items in collections. */
export type CollectionRef = {
  slug: Scalars['String']['input'];
  type: CollectionType;
};

export enum CollectionType {
  PERSONAL = 'PERSONAL',
  SERVICE = 'SERVICE',
  SIMPLE = 'SIMPLE',
}

export type CollectionsFilters = {
  /** If set, will also return inactive collections. If not provided that will also include inactive collections. */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only collections whose name contains the specified string will be returned. */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** If set, only collections who have the default notification policy set to the specified slug will be returned." */
  notificationPolicySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, only collections that are in the customer namespace will be returned. */
  onlyCustomerManaged?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only collections who are unowned will be returned. */
  requireUnowned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter returned collections by a set of team slugs. */
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, return collections matching the specified types */
  types?: InputMaybe<Array<InputMaybe<CollectionType>>>;
};

export enum CommandCenterAlertSeverity {
  CRITICAL = 'CRITICAL',
  INVALID = 'INVALID',
  WARN = 'WARN',
}

export enum CommandCenterAlertState {
  INVALID = 'INVALID',
  RESOLVED = 'RESOLVED',
  TRIGGERED = 'TRIGGERED',
}

export type CommentSearchFilter = {
  authorEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRefMatcher?: InputMaybe<CommentStringMatcherInput>;
  targetTypes?: InputMaybe<Array<TargetType>>;
  textContains?: InputMaybe<Scalars['String']['input']>;
};

/** CommentStringMatcherInput defines string matching operations for filtering. */
export type CommentStringMatcherInput = {
  /** Multiple values for operations like ANY_OF, NONE_OF. */
  multiValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The string matching operation to perform. */
  operation: CommentStringMatcherOperation;
  /** Single value for operations like EQUAL, NOT_EQUAL, CONTAINS, etc. */
  singleValue?: InputMaybe<Scalars['String']['input']>;
};

/** CommentStringMatcherOperation defines the available string matching operations. */
export enum CommentStringMatcherOperation {
  /** Matches any of the provided values. */
  ANY_OF = 'ANY_OF',
  /** Contains substring match. */
  CONTAINS = 'CONTAINS',
}

export type CommentsListInput = {
  id: Scalars['ID']['input'];
};

export type ComponentDiscoveryOverrideInput = {
  metric?: InputMaybe<MetricDiscoveryOverrideInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  status?: InputMaybe<ComponentDiscoveryOverrideStatus>;
};

export enum ComponentDiscoveryOverrideStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type ComponentPresentationDiffInput = {
  eligibility: EligibilityCriteriaInput;
  slug: Scalars['String']['input'];
  status: ComponentPresentationOverrideStatus;
};

export type ComponentPresentationOverrideInput = {
  componentPresentationSlug: Scalars['String']['input'];
  status: ComponentPresentationOverrideStatus;
};

export enum ComponentPresentationOverrideStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum ComponentPresentationType {
  EVENTS = 'EVENTS',
  PANELS = 'PANELS',
  UNKNOWN = 'UNKNOWN',
}

export enum ComponentType {
  COMPUTE = 'COMPUTE',
  RPC = 'RPC',
  UNKNOWN = 'UNKNOWN',
}

export enum ConditionLevel {
  CRITICAL = 'CRITICAL',
  UNKNOWN = 'UNKNOWN',
  WARN = 'WARN',
}

/** ConfigEntityType represents the type of entity that generated an alert. */
export enum ConfigEntityType {
  /** Alert generated by a monitor */
  MONITOR = 'MONITOR',
  /** Alert generated by an SLO */
  SLO = 'SLO',
}

export type ConstructedLabelInput = {
  /** The value definitions for the constructed label. */
  valueDefinitions?: InputMaybe<Array<ValueDefinitionInput>>;
};

export type ConsumptionBudgetAlertActionConfigInput = {
  annotations?: InputMaybe<Scalars['JSONObject']['input']>;
  instantRateSustainSecs?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type ConsumptionBudgetExportInput = {
  alertActionConfig?: InputMaybe<ConsumptionBudgetAlertActionConfigInput>;
  defaultPriority?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notificationPolicySlug?: InputMaybe<Scalars['String']['input']>;
  partitionSlugPath: Scalars['String']['input'];
  priorities?: InputMaybe<Array<ConsumptionBudgetPriorityExportInput>>;
  resource: ConsumptionSkuGroup;
  slug?: InputMaybe<Scalars['String']['input']>;
  thresholds?: InputMaybe<Array<ConsumptionBudgetThresholdExportInput>>;
};

export type ConsumptionBudgetInstantRateInput = {
  fixedValuePerSec: Scalars['Int']['input'];
};

export type ConsumptionBudgetPriorityExportInput = {
  filters: Array<ConsumptionBudgetPriorityFilterExportInput>;
  priority: Scalars['Int']['input'];
};

export type ConsumptionBudgetPriorityFilterExportInput = {
  logFilter?: InputMaybe<LogSearchFilterInput>;
};

export enum ConsumptionBudgetStatus {
  ALERT_CRITICAL = 'ALERT_CRITICAL',
  ALERT_WARN = 'ALERT_WARN',
  DROPPING = 'DROPPING',
  NO_BUDGET = 'NO_BUDGET',
  OK = 'OK',
  UNKNOWN = 'UNKNOWN',
}

export enum ConsumptionBudgetThresholdAction {
  ALERT_CRITICAL = 'ALERT_CRITICAL',
  ALERT_WARN = 'ALERT_WARN',
  DROP = 'DROP',
}

export type ConsumptionBudgetThresholdExportInput = {
  action: ConsumptionBudgetThresholdAction;
  instantRate?: InputMaybe<ConsumptionBudgetInstantRateInput>;
  skuGroup: ConsumptionSkuGroup;
  type: ConsumptionBudgetThresholdType;
  unit: ConsumptionUnit;
  volume?: InputMaybe<ConsumptionBudgetVolumeInput>;
};

export enum ConsumptionBudgetThresholdType {
  DAILY_VOLUME = 'DAILY_VOLUME',
  HOURLY_VOLUME = 'HOURLY_VOLUME',
  INSTANT_RATE = 'INSTANT_RATE',
  MONTHLY_VOLUME = 'MONTHLY_VOLUME',
  ROLLING_1_DAY_VOLUME = 'ROLLING_1_DAY_VOLUME',
  ROLLING_1_HOUR_VOLUME = 'ROLLING_1_HOUR_VOLUME',
  ROLLING_3_HOUR_VOLUME = 'ROLLING_3_HOUR_VOLUME',
  ROLLING_7_DAY_VOLUME = 'ROLLING_7_DAY_VOLUME',
  WEEKLY_VOLUME = 'WEEKLY_VOLUME',
}

export type ConsumptionBudgetVolumeInput = {
  fixedValue: Scalars['Int']['input'];
};

export type ConsumptionConfigInput = {
  partitions: Array<ConsumptionConfigPartitionInput>;
};

export type ConsumptionConfigMetricFilterInput = {
  name: Scalars['String']['input'];
  valueGlob: Scalars['String']['input'];
};

export type ConsumptionConfigPartitionFilterConditionInput = {
  logFilter?: InputMaybe<LogSearchFilterInput>;
  metricFilters?: InputMaybe<Array<ConsumptionConfigMetricFilterInput>>;
};

export type ConsumptionConfigPartitionFilterInput = {
  conditions: Array<ConsumptionConfigPartitionFilterConditionInput>;
  operator: ConsumptionPartitionFilterOperator;
};

export type ConsumptionConfigPartitionInput = {
  filters?: InputMaybe<Array<ConsumptionConfigPartitionFilterInput>>;
  name: Scalars['String']['input'];
  partitions?: InputMaybe<Array<ConsumptionConfigPartitionInput>>;
  slug: Scalars['String']['input'];
};

export enum ConsumptionDerivedSku {
  EFFECTIVE_DATAPOINT_RESOLUTION = 'EFFECTIVE_DATAPOINT_RESOLUTION',
  HISTOGRAM_DATAPOINT_BUCKETS_PER_DATAPOINT = 'HISTOGRAM_DATAPOINT_BUCKETS_PER_DATAPOINT',
}

export enum ConsumptionPartitionFilterOperator {
  IN = 'IN',
  NOT_IN = 'NOT_IN',
}

export enum ConsumptionProduct {
  ALL = 'ALL',
  LOGS = 'LOGS',
  METRICS = 'METRICS',
  TRACES = 'TRACES',
}

export enum ConsumptionResource {
  LOG_PERSISTED_BYTES = 'LOG_PERSISTED_BYTES',
  LOG_PROCESSED_BYTES = 'LOG_PROCESSED_BYTES',
  METRIC_ALL = 'METRIC_ALL',
  METRIC_PERSISTED_SERIES = 'METRIC_PERSISTED_SERIES',
}

export enum ConsumptionSku {
  LOG_LTR_DATA_SCANNED_BYTES = 'LOG_LTR_DATA_SCANNED_BYTES',
  LOG_LTR_PERSISTED_BYTES = 'LOG_LTR_PERSISTED_BYTES',
  LOG_LTR_RETAINED_BYTES = 'LOG_LTR_RETAINED_BYTES',
  LOG_PERSISTED_BYTES = 'LOG_PERSISTED_BYTES',
  LOG_PROCESSED_BYTES = 'LOG_PROCESSED_BYTES',
  METRIC_MATCHED_DATAPOINTS = 'METRIC_MATCHED_DATAPOINTS',
  METRIC_MATCHED_HISTOGRAM_DATAPOINT_BUCKETS = 'METRIC_MATCHED_HISTOGRAM_DATAPOINT_BUCKETS',
  METRIC_PERSISTED_DATAPOINTS = 'METRIC_PERSISTED_DATAPOINTS',
  METRIC_PERSISTED_HISTOGRAM_DATAPOINT_BUCKETS = 'METRIC_PERSISTED_HISTOGRAM_DATAPOINT_BUCKETS',
  METRIC_PERSISTED_SERIES = 'METRIC_PERSISTED_SERIES',
  TRACE_PERSISTED_BYTES = 'TRACE_PERSISTED_BYTES',
  TRACE_PROCESSED_BYTES = 'TRACE_PROCESSED_BYTES',
}

export enum ConsumptionSkuGroup {
  ALL = 'ALL',
  LOG_ALL = 'LOG_ALL',
  LOG_LTR_DATA_SCANNED_BYTES = 'LOG_LTR_DATA_SCANNED_BYTES',
  LOG_LTR_PERSISTED_BYTES = 'LOG_LTR_PERSISTED_BYTES',
  LOG_LTR_RETAINED_BYTES = 'LOG_LTR_RETAINED_BYTES',
  LOG_PERSISTED_BYTES = 'LOG_PERSISTED_BYTES',
  LOG_PROCESSED_BYTES = 'LOG_PROCESSED_BYTES',
  METRIC_ALL = 'METRIC_ALL',
  METRIC_MATCHED_WRITES = 'METRIC_MATCHED_WRITES',
  METRIC_PERSISTED_SERIES = 'METRIC_PERSISTED_SERIES',
  METRIC_PERSISTED_WRITES = 'METRIC_PERSISTED_WRITES',
  TRACE_ALL = 'TRACE_ALL',
  TRACE_PERSISTED_BYTES = 'TRACE_PERSISTED_BYTES',
  TRACE_PROCESSED_BYTES = 'TRACE_PROCESSED_BYTES',
}

export enum ConsumptionTimeSeriesGroupBy {
  CONSUMED_BY_PARTITION = 'CONSUMED_BY_PARTITION',
  CONSUMED_BY_PRODUCT = 'CONSUMED_BY_PRODUCT',
  CONSUMED_BY_SKU = 'CONSUMED_BY_SKU',
  CONSUMED_VS_DROPPED = 'CONSUMED_VS_DROPPED',
  DROPPED_BY_PARTITION = 'DROPPED_BY_PARTITION',
}

export enum ConsumptionTimeSeriesThresholdSource {
  BUDGET_THRESHOLD = 'BUDGET_THRESHOLD',
  CONTRACT = 'CONTRACT',
}

export enum ConsumptionTimeSeriesView {
  CUMULATIVE = 'CUMULATIVE',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  MONTHLY_CUMULATIVE = 'MONTHLY_CUMULATIVE',
  PER_SECOND = 'PER_SECOND',
  ROLLING_1_DAY = 'ROLLING_1_DAY',
  ROLLING_1_HOUR = 'ROLLING_1_HOUR',
  ROLLING_3_HOUR = 'ROLLING_3_HOUR',
  ROLLING_7_DAY = 'ROLLING_7_DAY',
  WEEKLY = 'WEEKLY',
}

export enum ConsumptionTrendType {
  MONTH_OVER_MONTH = 'MONTH_OVER_MONTH',
  TIME_RANGE_OVER_PREVIOUS = 'TIME_RANGE_OVER_PREVIOUS',
  WEEK_OVER_WEEK = 'WEEK_OVER_WEEK',
}

export enum ConsumptionUnit {
  CREDITS = 'CREDITS',
  NATIVE = 'NATIVE',
}

export type CountFilterInput = {
  isMaxExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isMinExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type CreateCollection = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Optional slug of notification policy used by this collection */
  policySlug?: InputMaybe<Scalars['String']['input']>;
  /** Optional slug for the collection. If omitted, this will be assigned based on name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  team_slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  text: Scalars['String']['input'];
  threadID: Scalars['ID']['input'];
};

export type CreateCustomComponentInput = {
  dashboard: Scalars['JSONObject']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceTemplateVar?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDatasetInput = {
  description: Scalars['String']['input'];
  logConfiguration?: InputMaybe<LogDatasetConfigurationInput>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  traceConfiguration?: InputMaybe<TraceDatasetConfigurationInput>;
  type: DatasetType;
};

export type CreateDerivedLabelInput = {
  /** DerivedLabelSpanTag is used to map span tags to derived labels. */
  derivedLabelSpanTag?: InputMaybe<DerivedLabelSpanTagInput>;
  /** An optional description of the derived label. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** This field specifies the action taken when there's a metric label with the same name as this derived label. */
  existingLabelPolicy?: InputMaybe<DerivedLabelPolicy>;
  /** The name of the derived label. */
  labelName: Scalars['String']['input'];
  metricLabel?: InputMaybe<MetricLabelInput>;
  /** The name of the derived label. */
  name: Scalars['String']['input'];
  /** The unique slug of the derived label. */
  slug: Scalars['String']['input'];
};

export type CreateDiscoveryInput = {
  /** Discovery config for events. */
  events?: InputMaybe<EventDiscoveryInput>;
  /** Discovery config for metrics. */
  metrics?: InputMaybe<MetricsDiscoveryInput>;
  name: Scalars['String']['input'];
};

/**
 * Exactly one of slack, pagerduty, webhook, victorops, opsgenie, or cloudflare must be
 * provided.
 *
 * This mirrors the ExternalConnection response shape.
 */
export type CreateExternalConnectionInput = {
  cloudflare?: InputMaybe<ExternalConnectionCloudflareConfigInput>;
  name: Scalars['String']['input'];
  opsgenie?: InputMaybe<ExternalConnectionOpsGenieConfigInput>;
  pagerduty?: InputMaybe<ExternalConnectionPagerDutyConfigInput>;
  slack?: InputMaybe<ExternalConnectionSlackConfigInput>;
  /** Optional slug for the external connection. If omitted, one is generated from the name. */
  slug?: InputMaybe<Scalars['ID']['input']>;
  victorops?: InputMaybe<ExternalConnectionVictorOpsConfigInput>;
  webhook?: InputMaybe<ExternalConnectionWebhookConfigInput>;
};

export type CreateLinkTemplateInput = {
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['ID']['input']>;
  urlTemplate: Scalars['String']['input'];
};

export type CreateLogControlConfigInput = {
  dryRun: Scalars['Boolean']['input'];
  logControlConfig: LogControlConfigInput;
};

export type CreateLogIngestConfigInput = {
  dryRun: Scalars['Boolean']['input'];
  logIngestConfig: LogIngestConfigInput;
};

export type CreateLogLookupTableInput = {
  dryRun: Scalars['Boolean']['input'];
  logLookupTable: LogLookupTableInput;
};

export type CreateLogRetentionConfigInput = {
  dryRun: Scalars['Boolean']['input'];
  logRetentionConfig: LogRetentionConfigInput;
};

export type CreateNotebookInput = {
  /** Collection containing this notebook */
  collectionSlug: Scalars['String']['input'];
  /**
   * Type of the collection containing the notebook. Optional for backwards compatibility. Defaults to SIMPLE if not
   * specified.
   */
  collectionType?: InputMaybe<CollectionType>;
  /** Notebook name. Must be unique within a collection. */
  name: Scalars['String']['input'];
  /** Notebook JSON configuration. */
  notebookJSON: Scalars['JSONObject']['input'];
  /** Optional slug for the notebook. If omitted, one is generated from the name. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonalAccessTokenInput = {
  expiration: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatePresentationInput = {
  dashboard?: InputMaybe<PresentationDashboardInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  eligibility: PresentationEligibilityInput;
  events?: InputMaybe<PresentationEventsInput>;
  name: Scalars['String']['input'];
  numPanelsToDisplay?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSavedTraceSearchInput = {
  comparison?: InputMaybe<TraceSearchInput>;
  name: Scalars['String']['input'];
  search: TraceSearchInput;
  slug?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSearchHistoryInput = {
  search: NewSearchHistory;
};

export type CreateServiceAccountInput = {
  labels?: InputMaybe<Array<LabelInput>>;
  name: Scalars['String']['input'];
  permission?: InputMaybe<PermissionAction>;
};

export type CreateSignupInviteInput = {
  email: Scalars['String']['input'];
};

export type CreateSyntheticGlobalVariableInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** When true, validates the request without persisting. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Required on create. Never returned on read for secure variables. */
  secretValue: Scalars['String']['input'];
  secure: Scalars['Boolean']['input'];
  slug?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSyntheticTestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  httpTest?: InputMaybe<SyntheticTestHttpTestConfigInput>;
  intervalSecs: Scalars['Int']['input'];
  labels?: InputMaybe<Array<LabelInput>>;
  locations: Array<SyntheticTestLocation>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['ID']['input']>;
  status: SyntheticTestStatus;
  testType: SyntheticTestType;
};

export type CreateThreadInput = {
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetInput;
  /** This is the initial comment text for the thread */
  text: Scalars['String']['input'];
};

export type CreateTraceBehaviorInput = {
  baseHeadSampleRate?: InputMaybe<Scalars['Float']['input']>;
  baseTailSampleRate?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorSampleOptions?: InputMaybe<TraceBehaviorErrorSampleOptionsInput>;
  fastSampleOptions?: InputMaybe<TraceBehaviorFastSampleOptionsInput>;
  largeTraceSampleOptions?: InputMaybe<TraceBehaviorLargeTraceSampleOptionsInput>;
  name: Scalars['String']['input'];
  slowSampleOptions?: InputMaybe<TraceBehaviorSlowSampleOptionsInput>;
  slug?: InputMaybe<Scalars['ID']['input']>;
  smallTraceSampleOptions?: InputMaybe<TraceBehaviorSmallTraceSampleOptionsInput>;
};

export type CreateTraceMetricsRuleInput = {
  groupBys?: InputMaybe<Array<TraceMetricsGroupByInput>>;
  histogramBucketsSeconds: Array<Scalars['Float']['input']>;
  metricLabels: Array<LabelInput>;
  metricName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scopeFilter?: InputMaybe<ScopeFilterInput>;
  slug?: InputMaybe<Scalars['ID']['input']>;
  traceFilter: TraceSearchFilterInput;
};

export type CreateTraceSearchHistoryInput = {
  comparison?: InputMaybe<TraceSearchInput>;
  search: TraceSearchInput;
};

export type DarkModeInput = {
  darkMode: Scalars['Boolean']['input'];
};

export enum DashboardColumn {
  FAVORITES = 'FAVORITES',
  POPULARITY = 'POPULARITY',
}

export enum DashboardOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type DashboardOrdering = {
  column: DashboardColumn;
  order: DashboardOrder;
};

export type DatasetEnhancementsInput = {
  traceInput?: InputMaybe<TraceDatasetEnhancementsInput>;
  type: DatasetType;
};

export enum DatasetType {
  DATASET_TYPE_INVALID = 'DATASET_TYPE_INVALID',
  LOGS = 'LOGS',
  TRACES = 'TRACES',
}

export type DatasetsListFilterInput = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<DatasetType>;
};

export enum DatasourceType {
  GRAPHITE = 'GRAPHITE',
  LOGGING = 'LOGGING',
  PROMETHEUS = 'PROMETHEUS',
}

export type DebugLogFilter = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAlertNotificationPolicy = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAlertReceiver = {
  /** Deprecated, use slug when possible. */
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteCollection = {
  /** Required slug for the collection to delete. */
  slug: Scalars['ID']['input'];
};

/** Input for deleting a collection homepage if it exists. */
export type DeleteCollectionHomepageInput = {
  collectionSlug: Scalars['String']['input'];
};

/** DeleteCollectionLinksInput is an input type that specifies the identity of a collection link to delete. */
export type DeleteCollectionLinksInput = {
  slugs: Array<Scalars['String']['input']>;
};

export type DeleteCustomComponentInput = {
  slug: Scalars['String']['input'];
};

export type DeleteDashboard = {
  slug: Scalars['String']['input'];
};

export type DeleteDatasetInput = {
  slug: Scalars['String']['input'];
};

export type DeleteDerivedLabelInput = {
  slug: Scalars['String']['input'];
};

export type DeleteDiscoveryInput = {
  slug: Scalars['String']['input'];
};

export type DeleteDropRule = {
  slug: Scalars['String']['input'];
};

export type DeleteExternalConnectionInput = {
  slug: Scalars['String']['input'];
};

export type DeleteGrafanaDashboard = {
  slug: Scalars['String']['input'];
};

export type DeleteLinkTemplateInput = {
  slug: Scalars['ID']['input'];
};

export type DeleteLogRetentionConfigInput = {
  slug: Scalars['String']['input'];
};

export type DeleteMappingRule = {
  slug: Scalars['String']['input'];
};

export type DeleteMonitor = {
  slug: Scalars['String']['input'];
};

export type DeleteNotebookInput = {
  slug: Scalars['String']['input'];
};

export type DeletePersonalAccessTokensInput = {
  slugs: Array<Scalars['ID']['input']>;
};

export type DeletePresentationInput = {
  slug: Scalars['String']['input'];
};

export type DeleteRecordingRule = {
  id: Scalars['ID']['input'];
};

export type DeleteRollupRule = {
  slug: Scalars['String']['input'];
};

export type DeleteSLOInput = {
  slug: Scalars['String']['input'];
};

export type DeleteSavedTraceSearchInput = {
  slug: Scalars['ID']['input'];
};

export type DeleteSearchHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteServiceAccountInput = {
  id: Scalars['String']['input'];
};

export type DeleteServiceAccountsInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DeleteSyntheticGlobalVariableInput = {
  /** When true, returns referencingTests without deleting the variable. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['ID']['input'];
};

export type DeleteSyntheticTestInput = {
  slug: Scalars['ID']['input'];
};

export type DeleteTeam = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for deleting a team homepage if it exists. */
export type DeleteTeamHomepageInput = {
  teamSlug: Scalars['String']['input'];
};

export type DeleteTraceBehaviorInput = {
  slug: Scalars['ID']['input'];
};

export type DeleteTraceMetricsRuleInput = {
  slug: Scalars['String']['input'];
};

export type DeleteUserInput = {
  /** Deactivate the user first before deleting, even if they were not deactivated */
  forceDeactivate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DerivedLabelFilterInput = {
  /** The name of the field in a Prom expression that is being used to filter results */
  name: Scalars['String']['input'];
  /** A glob match of possible values for the field */
  valueGlob: Scalars['String']['input'];
};

export enum DerivedLabelPolicy {
  /** Keep the existing label. */
  KEEP = 'KEEP',
  /** Invalid label policy. */
  LABEL_POLICY_INVALID = 'LABEL_POLICY_INVALID',
  /** Override the existing label. */
  OVERRIDE = 'OVERRIDE',
}

export type DerivedLabelPreviewInput = {
  derivedLabel: CreateDerivedLabelInput;
  endTime: Scalars['Time']['input'];
  startTime: Scalars['Time']['input'];
};

export type DerivedLabelSpanTagInput = {
  /** The name mappings for the span tag. */
  nameMappings?: InputMaybe<Array<DerivedLabelSpanTagNameMappingInput>>;
};

export type DerivedLabelSpanTagNameMappingInput = {
  /** The source tag to be mapped to the derived tag. */
  sourceTag: Scalars['String']['input'];
};

export type DerivedLabelValueMappingInput = {
  /** Defines the source label values that should be mapped into the given target value. */
  sourceValueGlobs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The value that source_value_globs are mapped into. */
  targetValue: Scalars['String']['input'];
};

export type DiscoveryConfigsInput = {
  debugLogFilter?: InputMaybe<DebugLogFilter>;
  discoveryOverrides?: InputMaybe<Array<ComponentDiscoveryOverrideInput>>;
  /** @deprecated replaced with discoveryOverrides */
  overrides?: InputMaybe<Array<ComponentDiscoveryOverrideInput>>;
  rules?: InputMaybe<Array<ObjectMergeRuleInput>>;
  /**
   * The discovery pipeline caches the results of the most recent run
   * as well a few of the results of the most recent dry runs.
   * The discovery pipeline only reads from the cache for dry runs.
   * Setting this field to true will force a dry run to run the entire
   * discovery pipeline even if there is a cached result already.
   * If this is not a dry run, this field does nothing.
   */
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
  suppressionExemptServices?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum DiscoveryPipelineStatusMessageCode {
  CANDIDATE_EXCEEDS_DIMENSION_COUNT = 'CANDIDATE_EXCEEDS_DIMENSION_COUNT',
  CONFLICTING_MAPPING_VALUES = 'CONFLICTING_MAPPING_VALUES',
  EMPTY_SERVICE_OWNS_ENTITIES = 'EMPTY_SERVICE_OWNS_ENTITIES',
  MULTIPLE_SERVICE_NAMES = 'MULTIPLE_SERVICE_NAMES',
  SOURCE_LABEL_MISSING = 'SOURCE_LABEL_MISSING',
  TOO_MANY_RESULTS = 'TOO_MANY_RESULTS',
  UNIQUE_SOURCE_LABEL_NOT_FOUND = 'UNIQUE_SOURCE_LABEL_NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
}

export enum DiscoveryPipelineStatusMessageSeverity {
  ERROR = 'ERROR',
  INFO = 'INFO',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING',
}

export enum DiscoveryStatus {
  Added = 'Added',
  Deleted = 'Deleted',
  Modified = 'Modified',
  Unchanged = 'Unchanged',
  Unknown = 'Unknown',
}

export enum DocArtifactSortField {
  CREATED_AT = 'CREATED_AT',
  KEY = 'KEY',
  LABEL_NAME = 'LABEL_NAME',
  UPDATED_AT = 'UPDATED_AT',
}

/**
 * DocArtifactSortOrder is a structured sort input.
 *
 * If field == LABEL_NAME, labelName must be provided to indicate which label to sort by.
 */
export type DocArtifactSortOrder = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  field: DocArtifactSortField;
  /** Label name to sort by. Must be set when field is LABEL_NAME. */
  labelName?: InputMaybe<Scalars['String']['input']>;
};

export enum DropRuleMode {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  PREVIEW = 'PREVIEW',
}

export type DurationFilterInput = {
  maxSeconds: Scalars['Float']['input'];
  minSeconds: Scalars['Float']['input'];
};

export enum EditSource {
  EDITABLE = 'EDITABLE',
  UNEDITABLE_K8S_OWNED = 'UNEDITABLE_K8S_OWNED',
  UNEDITABLE_SLO_GENERATED = 'UNEDITABLE_SLO_GENERATED',
  UNEDITABLE_TF_OWNED = 'UNEDITABLE_TF_OWNED',
}

export type EligibilityCriteriaInput = {
  allowedServices?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoredServices?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredDiscoveries?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutDiscoveries?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EligibleServicesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  eligibility: EligibilityCriteriaInput;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type EmitMetricsCounterInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum EmitMetricsGaugeAggregationType {
  LAST = 'LAST',
  MAX = 'MAX',
  MIN = 'MIN',
}

export type EmitMetricsGaugeInput = {
  aggregationType: EmitMetricsGaugeAggregationType;
  value: Scalars['String']['input'];
};

export type EmitMetricsHistogramInput = {
  value: Scalars['String']['input'];
};

export type EmitMetricsLabelInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum EmitMetricsMode {
  COUNTER = 'COUNTER',
  GAUGE = 'GAUGE',
  HISTOGRAM = 'HISTOGRAM',
}

export enum EntityNamespace {
  CUSTOMER = 'CUSTOMER',
  INTERNAL = 'INTERNAL',
  MANAGED = 'MANAGED',
}

export type EntityVersionFilters = {
  /** The slug of the entity whose versions to fetch. */
  slug: Scalars['String']['input'];
  /**
   * Optional sources to filter on
   * If multiple sources are provided, the results are "OR'd" together. If used wth other
   * filters, then the filtered results are "AND'd" together.
   */
  sources?: InputMaybe<Array<EntityVersionSource>>;
  /** Optional time range to filter versions within */
  timeRange?: InputMaybe<NewTimeRange>;
  /** The type of the entity whose versions to fetch. */
  type: EntityVersionType;
  /** Sort order for versions, will default to descending */
  versionOrder?: InputMaybe<EntityVersionOrder>;
};

export enum EntityVersionOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum EntityVersionSource {
  API = 'API',
  CHRONOCTL = 'CHRONOCTL',
  TERRAFORM = 'TERRAFORM',
  UI = 'UI',
  UNKNOWN = 'UNKNOWN',
}

export enum EntityVersionType {
  DASHBOARD = 'DASHBOARD',
  LOG_CONTROL_CONFIG = 'LOG_CONTROL_CONFIG',
  LOG_INGEST_CONFIG = 'LOG_INGEST_CONFIG',
  LOG_RETENTION_CONFIG = 'LOG_RETENTION_CONFIG',
  MONITOR = 'MONITOR',
  NOTEBOOK = 'NOTEBOOK',
  SLO = 'SLO',
}

export type ErrorCodeDefInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  isSuccess: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type EventDiscoveryInput = {
  /** Change events label name to use to discover service names. Values of this label will be used as candidates for service names. */
  serviceNameLabel: Scalars['String']['input'];
};

export enum ExportFormat {
  CHRONOCTL = 'CHRONOCTL',
  TERRAFORM = 'TERRAFORM',
  UNKNOWN = 'UNKNOWN',
}

export type ExternalConnectionCloudflareConfigInput = {
  /**
   * Cloudflare API Token. Accepts User API Tokens (cfut_ prefix) and Account
   * API Tokens (cfat_ prefix).
   */
  apiToken?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalConnectionHTTPBasicAuthInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalConnectionHTTPConfigInput = {
  basicAuth?: InputMaybe<ExternalConnectionHTTPBasicAuthInput>;
  bearerToken?: InputMaybe<Scalars['String']['input']>;
  tlsConfig?: InputMaybe<ExternalConnectionHTTPTLSConfigInput>;
};

export type ExternalConnectionHTTPTLSConfigInput = {
  insecureSkipVerify: Scalars['Boolean']['input'];
};

export type ExternalConnectionOpsGenieConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<ExternalConnectionHTTPConfigInput>;
};

export type ExternalConnectionPagerDutyConfigInput = {
  /**
   * PagerDuty Events API configuration.
   * This is the only supported PagerDuty variant today.
   */
  events?: InputMaybe<ExternalConnectionPagerDutyEventsConfigInput>;
};

export type ExternalConnectionPagerDutyEventsConfigInput = {
  /**
   * The PagerDuty integration key. PagerDuty calls this a "routing key" for
   * Events v2 and a "service key" for Events v1.
   */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** The PagerDuty Events API version to use. Defaults to V2. */
  version?: InputMaybe<PagerDutyEventsVersion>;
};

export type ExternalConnectionSlackConfigInput = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export enum ExternalConnectionType {
  CLOUDFLARE = 'CLOUDFLARE',
  OPSGENIE = 'OPSGENIE',
  PAGERDUTY = 'PAGERDUTY',
  SLACK = 'SLACK',
  VICTOROPS = 'VICTOROPS',
  WEBHOOK = 'WEBHOOK',
}

export type ExternalConnectionVictorOpsConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalConnectionWebhookConfigInput = {
  httpConfig?: InputMaybe<ExternalConnectionHTTPConfigInput>;
  url: Scalars['String']['input'];
};

export type ExternalConnectionsListFilterInput = {
  connectionTypes?: InputMaybe<Array<ExternalConnectionType>>;
  /** If set, only external connections whose name or slug contains the specified string will be returned. */
  nameOrSlugContains?: InputMaybe<Scalars['String']['input']>;
};

export enum FavoriteEntityType {
  DASHBOARD = 'DASHBOARD',
  GRAFANA_DASHBOARD = 'GRAFANA_DASHBOARD',
  MONITOR = 'MONITOR',
  SLO = 'SLO',
}

export type FeatureFlagRequest = {
  /** The value type that the flag is expected to return. */
  flagType: FeatureFlagType;
  /** The key by which the flag is defined in LaunchDarkly. */
  key: Scalars['String']['input'];
};

export enum FeatureFlagType {
  BOOL = 'BOOL',
  INT = 'INT',
  STRING = 'STRING',
}

export type FieldNormalizationInput = {
  customFieldNormalization?: InputMaybe<Array<NamedStringNormalizationInput>>;
  message?: InputMaybe<StringNormalizationInput>;
  service?: InputMaybe<StringNormalizationInput>;
  severity?: InputMaybe<StringNormalizationInput>;
  timestamp?: InputMaybe<TimestampNormalizationInput>;
};

export type GrafanaDashboardFilter = {
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set and set to true, filters to only favorites */
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<LabelInput>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GrafanaDashboardSettings = {
  /**
   * Collection where this dashboard belongs. Saving with a different collection slug will move
   * the dashboard from the old collection to the new collection.
   */
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Type of the collection containing the dashboard. Optional for backwards compatibility. Defaults to SIMPLE if not
   * specified.
   */
  collectionType?: InputMaybe<CollectionType>;
  /** Labels for dashboards. These correspond to "tags" in grafana. The only valid key is "grafanaTag". */
  labels?: InputMaybe<Array<LabelInput>>;
  /** Name of the dashboard. This maps to a grafana dashboard title. */
  name: Scalars['String']['input'];
  /**
   * Slug is a unique identifier for dashboards. Saving a dashboard without a slug will
   * create a new dashboard and generate a new slug. This field maps to a grafana dashboard uid.
   *
   * If a dashboard with this slug already exists, this will overwrite the dashboard.
   */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type GrokParserInput = {
  pattern: Scalars['String']['input'];
};

export type ImportGrafanaDashboard = {
  /**
   * Grafana dashboard json. Any differences in name, uid (slug) or tags (labels)
   * in the dashboard json will be overridden by corresponding fields in the settings.
   */
  dashboardJSON: Scalars['String']['input'];
  settings: GrafanaDashboardSettings;
};

export type InputDropRuleValueBasedDrop = {
  enabled: Scalars['Boolean']['input'];
  targetDropValue: Scalars['Float']['input'];
};

export type InputGraphiteLabelPolicy = {
  replace?: InputMaybe<Array<InputMaybe<InputGraphiteLabelPolicyReplace>>>;
};

export type InputGraphiteLabelPolicyReplace = {
  name: Scalars['String']['input'];
  newValue: Scalars['String']['input'];
};

export type InputLabelPolicy = {
  discard?: InputMaybe<Array<Scalars['String']['input']>>;
  keep?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputMappingRuleAggregationPolicy = {
  aggregation: AggregationType;
  dropTimestamp: Scalars['Boolean']['input'];
  interval?: InputMaybe<Scalars['String']['input']>;
  storagePolicy?: InputMaybe<InputStoragePolicy>;
};

export type InputRollupRuleLabelReplace = {
  dstLabelName?: InputMaybe<Scalars['String']['input']>;
  keepLabel?: InputMaybe<Scalars['Boolean']['input']>;
  labelValueRegex?: InputMaybe<Scalars['String']['input']>;
  newLabelValue: Scalars['String']['input'];
  srcLabelName: Scalars['String']['input'];
};

export type InputStoragePolicy = {
  resolution: Scalars['String']['input'];
  retention: Scalars['String']['input'];
};

/** InvestigationStatus represents the current state of an investigation. */
export enum InvestigationStatus {
  /** Investigation completed successfully. */
  COMPLETED = 'COMPLETED',
  /** Investigation failed. */
  FAILED = 'FAILED',
  /** Investigation is currently running. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Investigation completed with a few artifacts but no useful next steps. */
  PARTIAL = 'PARTIAL',
  /** Investigation completed with an idea of next steps but lacks confidence. */
  PARTIAL_USEFUL = 'PARTIAL_USEFUL',
  /** Status is unknown or unset. */
  UNKNOWN = 'UNKNOWN',
}

export type K8sContextDiscoveryInput = {
  deployment?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  includeEventInference?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedResources?: InputMaybe<Scalars['Boolean']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  node?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type KeyValueParserInput = {
  delimiter: Scalars['String']['input'];
  pairSeparator: Scalars['String']['input'];
  trimSet?: InputMaybe<Scalars['String']['input']>;
};

export type KnownMetricInput = {
  kind: MetricKind;
  metricName: Scalars['String']['input'];
};

export type LabelFilter = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LabelInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LabelMatcherInput = {
  name: Scalars['String']['input'];
  /** The operator to use in the filter. Must be "=" or "!=". */
  op: LabelMatcherOp;
  value: Scalars['String']['input'];
};

export enum LabelMatcherOp {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
}

export enum LabelMatcherType {
  EXACT_MATCHER_TYPE = 'EXACT_MATCHER_TYPE',
  NOT_EXACT_MATCHER_TYPE = 'NOT_EXACT_MATCHER_TYPE',
  NOT_REGEXP_MATCHER_TYPE = 'NOT_REGEXP_MATCHER_TYPE',
  REGEXP_MATCHER_TYPE = 'REGEXP_MATCHER_TYPE',
}

export type LabelValuesInput = {
  matcher: Scalars['String']['input'];
};

export type LinkInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ListDocArtifactsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  keyPrefix: Scalars['String']['input'];
  matchers?: InputMaybe<Array<LabelMatcherInput>>;
  order?: InputMaybe<DocArtifactSortOrder>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type LogControlConfigInput = {
  rules: Array<LogControlRuleInput>;
};

export type LogControlRuleDropFieldInput = {
  fieldRegex: Scalars['String']['input'];
  parentPath?: InputMaybe<Scalars['String']['input']>;
};

export type LogControlRuleEmitMetricsInput = {
  counter?: InputMaybe<EmitMetricsCounterInput>;
  dropLog: Scalars['Boolean']['input'];
  gauge?: InputMaybe<EmitMetricsGaugeInput>;
  histogram?: InputMaybe<EmitMetricsHistogramInput>;
  labels: Array<EmitMetricsLabelInput>;
  mode: EmitMetricsMode;
  name: Scalars['String']['input'];
};

export type LogControlRuleInput = {
  dropField?: InputMaybe<LogControlRuleDropFieldInput>;
  emitMetrics?: InputMaybe<LogControlRuleEmitMetricsInput>;
  filter: Scalars['String']['input'];
  mode: LogControlRuleMode;
  name: Scalars['String']['input'];
  parseField?: InputMaybe<LogControlRuleParseFieldInput>;
  replaceField?: InputMaybe<LogControlRuleReplaceFieldInput>;
  sample?: InputMaybe<LogControlRuleSampleInput>;
  type: LogControlRuleType;
};

export enum LogControlRuleMode {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type LogControlRuleParseFieldInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  parser: LogParserInput;
  source: Scalars['String']['input'];
};

export type LogControlRuleReplaceFieldInput = {
  field: Scalars['String']['input'];
  mappedValue?: InputMaybe<ReplaceFieldMappedValueInput>;
  replaceAll: Scalars['Boolean']['input'];
  replaceMode: ReplaceFieldMode;
  replaceRegex: Scalars['String']['input'];
  staticValue?: InputMaybe<ReplaceFieldStaticValueInput>;
};

export type LogControlRuleSampleInput = {
  rate: Scalars['Float']['input'];
};

export enum LogControlRuleType {
  DROP = 'DROP',
  DROP_FIELD = 'DROP_FIELD',
  EMIT_METRICS = 'EMIT_METRICS',
  PARSE_FIELD = 'PARSE_FIELD',
  REPLACE_FIELD = 'REPLACE_FIELD',
  SAMPLE = 'SAMPLE',
}

export type LogDatasetConfigurationInput = {
  filter: LogSearchFilterInput;
};

export type LogEventsInput = {
  events: Array<AnalyticsEventInput>;
};

export type LogFieldParserInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  mode: ParserMode;
  parser: LogParserInput;
  source: Scalars['String']['input'];
};

export type LogIngestConfigInput = {
  fieldNormalization?: InputMaybe<FieldNormalizationInput>;
  fieldParsers: Array<LogFieldParserInput>;
  plaintextParsers: Array<PlaintextParserInput>;
};

export enum LogLookupTableErrorDetails {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVALID_FILE = 'INVALID_FILE',
}

export type LogLookupTableInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum LogLookupTableStatus {
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  PENDING_DELETION = 'PENDING_DELETION',
  READY = 'READY',
}

export type LogParserInput = {
  grokParser?: InputMaybe<GrokParserInput>;
  keyValueParser?: InputMaybe<KeyValueParserInput>;
  parserType: LogParserType;
  regexParser?: InputMaybe<RegexParserInput>;
};

export enum LogParserType {
  GROK = 'GROK',
  JSON = 'JSON',
  KEY_VALUE = 'KEY_VALUE',
  REGEX = 'REGEX',
}

export type LogRetentionConfigInput = {
  filter: Scalars['String']['input'];
  longTermRetention: LogRetentionConfigLongTermRetentionInput;
  mode: LogRetentionConfigMode;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type LogRetentionConfigLongTermRetentionInput = {
  retentionDays: Scalars['Int']['input'];
};

export enum LogRetentionConfigMode {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type LogSearchFilterInput = {
  query: Scalars['String']['input'];
};

export enum LoggingContractState {
  ACTIVE = 'ACTIVE',
  TERMINATED = 'TERMINATED',
}

export enum ManagedBySource {
  CHRONOCTL = 'CHRONOCTL',
  CHRONOSPHERE = 'CHRONOSPHERE',
  KUBERNETES = 'KUBERNETES',
  SYNC_PROMETHEUS = 'SYNC_PROMETHEUS',
  TERRAFORM = 'TERRAFORM',
  UI = 'UI',
  UNKNOWN = 'UNKNOWN',
}

export type MappingLabelInput = {
  /** The name mappings for the mapping label. */
  nameMappings?: InputMaybe<Array<NameMappingInput>>;
  /**
   * These value mappings apply to the whole mapping label.
   * If there's no name_mappings, these value mappings apply to the label that exists on the metric.
   */
  valueMappings?: InputMaybe<Array<DerivedLabelValueMappingInput>>;
};

export enum MappingRuleMode {
  ENABLED = 'ENABLED',
  PREVIEW = 'PREVIEW',
}

export enum Match {
  INVALID = 'INVALID',
  RULE = 'RULE',
}

export type MetricDDXRequest = {
  addFilters?: InputMaybe<Array<InputMaybe<NewLabelMatcher>>>;
  endTime: Scalars['String']['input'];
  query: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type MetricDiscoveryMetadataInput = {
  knownMetrics?: InputMaybe<Array<KnownMetricInput>>;
  rpcMetadata?: InputMaybe<RPCInput>;
};

export type MetricDiscoveryOverrideInput = {
  expr?: InputMaybe<Scalars['String']['input']>;
  markerComponent?: InputMaybe<Scalars['Boolean']['input']>;
  objectLabel: Scalars['String']['input'];
  objectMappingLabel: Scalars['String']['input'];
  objectMappingLabelTransform?: InputMaybe<TransformInput>;
  target?: InputMaybe<MetricDiscoveryTargetInput>;
  uniqueLabel: Scalars['String']['input'];
};

export type MetricDiscoveryTargetInput = {
  filters: Array<DerivedLabelFilterInput>;
};

export enum MetricKind {
  FAILURE_METRIC = 'FAILURE_METRIC',
  LATENCY_HISTOGRAM_BUCKET = 'LATENCY_HISTOGRAM_BUCKET',
  LATENCY_HISTOGRAM_COUNT = 'LATENCY_HISTOGRAM_COUNT',
  SUCCESS_METRIC = 'SUCCESS_METRIC',
  TOTAL_METRIC = 'TOTAL_METRIC',
  UNKNOWN = 'UNKNOWN',
}

export type MetricLabelInput = {
  /** A constructed label creates a label where there previously exists none. */
  constructedLabel?: InputMaybe<ConstructedLabelInput>;
  /** A mapping label is a kind of derived label that is generated by pulling values from some other label on the timeseries. */
  mappingLabel?: InputMaybe<MappingLabelInput>;
};

export type MetricMetadataGeneratedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  generatedBy?: InputMaybe<Scalars['String']['input']>;
  metricName: Scalars['String']['input'];
};

export type MetricMetadataUserInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  metricName: Scalars['String']['input'];
};

export enum MetricType {
  COUNTER = 'COUNTER',
  CUMULATIVE_COUNTER = 'CUMULATIVE_COUNTER',
  CUMULATIVE_EXPONENTIAL_HISTOGRAM = 'CUMULATIVE_EXPONENTIAL_HISTOGRAM',
  DELTA = 'DELTA',
  DELTA_COUNTER = 'DELTA_COUNTER',
  DELTA_EXPONENTIAL_HISTOGRAM = 'DELTA_EXPONENTIAL_HISTOGRAM',
  DISTRIBUTION = 'DISTRIBUTION',
  GAUGE = 'GAUGE',
  MEASUREMENT = 'MEASUREMENT',
  METRIC_TYPE_INVALID = 'METRIC_TYPE_INVALID',
}

export type MetricsDiscoveryInput = {
  /** A Prom expression (usually a metric name) which generates results that directly or indirectly can enumerate services. */
  expr: Scalars['String']['input'];
  /** Indicates that this component is used only for discovery and does not modify lens_service. */
  markerComponent?: InputMaybe<Scalars['Boolean']['input']>;
  metricMetadata?: InputMaybe<MetricDiscoveryMetadataInput>;
  /** The name of a label in the results from the expression that directly enumerates service names. */
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of a label in the results from the expression whose values can be used to map to a service name
   * that was discovered by the "global configuration".
   */
  objectMappingLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * An optional transformation that is applied to values of `objectMappingLabel` before the values are used to search
   * the global configuration for proper service names.
   */
  objectMappingLabelTransform?: InputMaybe<TransformInput>;
  /** Configures which subset of the expression results the discovery should apply to. */
  target: MetricDiscoveryTargetInput;
  /** The name of a label in the results from the expression whose values uniquely correspond to services. */
  uniqueLabel?: InputMaybe<Scalars['String']['input']>;
};

export type MigrateGrafanaDashboardInput = {
  nativeDashboardConfig: Scalars['JSONObject']['input'];
  /** The grafana dashboard slug. The native dashboard created will have the same slug. */
  slug: Scalars['String']['input'];
};

export type MonitorInformation = {
  /** The specified severity. Valid options include: ['', 'FIRING', 'CRITICAL']. */
  severity: Scalars['String']['input'];
  /** The selected monitor signal if one is selected. */
  signal: Array<NewAlertRuleLabel>;
  /** The monitor slug. */
  slug: Scalars['String']['input'];
};

export type MonitorsV2Filters = {
  /** Filter duplicate results. if true response times may be faster but some monitors may be returned multiple times. */
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set to true, filters to only monitors marked as favorite by the calling user. */
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, search for dashboards that are owned by the filtered collections as well as
   * those linked to the filtered collections.
   */
  includeLinkedCollections?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specify which AlertStates to include in the response. If none are specified, all states are included. */
  includeStates?: InputMaybe<Array<AlertState>>;
  /** If set, only monitors whose name contains the specified string will be returned. */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** If set, only monitors whose name or slug contains the specified string will be returned. */
  nameOrSlugContains?: InputMaybe<Scalars['String']['input']>;
  /** If set, only monitors that use the provided notification policies will be returned. */
  notificationPolicySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, only monitors that are in the customer namespace will be returned. */
  onlyCustomerManaged?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only monitors with the specified slugs will be returned. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MutingRuleColumn {
  ENDS_AT = 'ENDS_AT',
  STARTS_AT = 'STARTS_AT',
}

export type MutingRuleOrdering = {
  column: MutingRuleColumn;
  order: Ordering;
};

export type MutingRulePageFilters = {
  /**
   * Specifies which states (pending, active, expired) muting rules to include in the response.
   * If none are specfied, all states are included in the response.
   */
  includeStates: Array<MutingRuleState>;
  /** If set, only muting rules whose name contains the specified string will be returned. */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the order in which muting rules should be sorted in. Only one ordering column is supported. */
  order: Array<MutingRuleOrdering>;
  /** If set, only muting rules whose payload contains the specified string will be returned. */
  payloadContains?: InputMaybe<Scalars['String']['input']>;
};

export enum MutingRuleState {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
}

export type NameMappingInput = {
  /** The filters that define the source label. */
  filters?: InputMaybe<Array<DerivedLabelFilterInput>>;
  /** The actual label ingested on the time series. */
  sourceLabel: Scalars['String']['input'];
  /** The value mappings for the name mapping. */
  valueMappings?: InputMaybe<Array<DerivedLabelValueMappingInput>>;
};

export type NamedStringNormalizationInput = {
  normalization: StringNormalizationInput;
  target: Scalars['String']['input'];
};

export type NewAlertNotificationPolicy = {
  name?: InputMaybe<Scalars['String']['input']>;
  routes?: InputMaybe<NewNotificationRoutes>;
  rules?: InputMaybe<Array<NewNotificationRule>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teamSlug?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiver = {
  email?: InputMaybe<Array<NewAlertReceiverEmailConfig>>;
  name: Scalars['String']['input'];
  opsgenie?: InputMaybe<Array<NewAlertReceiverOpsGenieConfig>>;
  pagerduty?: InputMaybe<Array<NewAlertReceiverPagerdutyConfig>>;
  slack?: InputMaybe<Array<NewAlertReceiverSlackConfig>>;
  victorOps?: InputMaybe<Array<NewAlertReceiverVictorOpsConfig>>;
  webhook?: InputMaybe<Array<NewAlertReceiverWebhookConfig>>;
};

export type NewAlertReceiverEmailConfig = {
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  html?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type NewAlertReceiverHTTPConfig = {
  basicAuth?: InputMaybe<NewAlertReceiverHTTPConfigBasicAuth>;
  bearerToken?: InputMaybe<Scalars['String']['input']>;
  proxyURL?: InputMaybe<Scalars['String']['input']>;
  tlsConfig?: InputMaybe<NewAlertReceiverHTTPConfigTLSConfig>;
};

export type NewAlertReceiverHTTPConfigBasicAuth = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type NewAlertReceiverHTTPConfigTLSConfig = {
  insecureSkipVerify: Scalars['Boolean']['input'];
};

export type NewAlertReceiverNotifierBaseConfig = {
  sendResolved: Scalars['Boolean']['input'];
};

export type NewAlertReceiverOpsGenieConfig = {
  apiKey: Scalars['String']['input'];
  apiURL: Scalars['String']['input'];
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  message?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  responders?: InputMaybe<Array<NewAlertReceiverOpsGenieConfigResponder>>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiverOpsGenieConfigResponder = {
  responderType: ResponderType;
  responderValue: Scalars['String']['input'];
  responseType: ResponseType;
};

export type NewAlertReceiverPagerdutyConfig = {
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  class?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  clientURL?: InputMaybe<Scalars['String']['input']>;
  component?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  images?: InputMaybe<Array<NewAlertReceiverPagerdutyConfigImage>>;
  links?: InputMaybe<Array<NewAlertReceiverPagerdutyConfigLink>>;
  serviceKey?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiverPagerdutyConfigImage = {
  alt: Scalars['String']['input'];
  href: Scalars['String']['input'];
  src: Scalars['String']['input'];
};

export type NewAlertReceiverPagerdutyConfigLink = {
  href: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type NewAlertReceiverSlackConfig = {
  actions?: InputMaybe<Array<NewAlertReceiverSlackConfigAction>>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  callbackID?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  fallback?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<NewAlertReceiverSlackConfigField>>;
  footer?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  iconEmoji?: InputMaybe<Scalars['String']['input']>;
  iconURL?: InputMaybe<Scalars['String']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  linkNames?: InputMaybe<Scalars['Boolean']['input']>;
  mrkdwnIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pretext?: InputMaybe<Scalars['String']['input']>;
  shortFields?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  thumbURL?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleLink?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiverSlackConfigAction = {
  confirm?: InputMaybe<NewAlertReceiverSlackConfigConfirmField>;
  name: Scalars['String']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewAlertReceiverSlackConfigConfirmField = {
  dismissText: Scalars['String']['input'];
  okText: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type NewAlertReceiverSlackConfigField = {
  short: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewAlertReceiverVictorOpsConfig = {
  apiKey: Scalars['String']['input'];
  apiURL: Scalars['String']['input'];
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  entityDisplayName?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  monitoringTool?: InputMaybe<Scalars['String']['input']>;
  routingKey?: InputMaybe<Scalars['String']['input']>;
  stateMessage?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiverWebhookConfig = {
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  url: Scalars['String']['input'];
};

export type NewAlertRouteMatcher = {
  name: Scalars['String']['input'];
  type: AlertRouteMatcherType;
  value: Scalars['String']['input'];
};

export type NewAlertRuleAnnotation = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewAlertRuleLabel = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewConditionOverride = {
  conditions: Array<NewSeverityCondition>;
  matchers?: InputMaybe<Array<NewAlertRouteMatcher>>;
};

export type NewDefaultResourcePool = {
  /** @deprecated DefaultPool allocation is deprecated and no longer must be specified. When unspecified, allocation is derived as the remaining amount from the sum across pools. */
  allocation?: InputMaybe<NewResourcePoolAllocation>;
  priorities?: InputMaybe<NewResourcePoolHighLowPriorities>;
  priorityThresholds?: InputMaybe<Array<NewResourcePoolAllocationThresholds>>;
};

export type NewDropRule = {
  dropNanValue?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Array<LabelFilter>;
  mode: DropRuleMode;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  valueBasedDrop?: InputMaybe<InputDropRuleValueBasedDrop>;
};

export type NewLabelMatcher = {
  name: Scalars['String']['input'];
  type: LabelMatcherType;
  value: Scalars['String']['input'];
};

export type NewMappingRule = {
  aggregationPolicy?: InputMaybe<InputMappingRuleAggregationPolicy>;
  drop: Scalars['Boolean']['input'];
  filters: Array<LabelFilter>;
  mode: MappingRuleMode;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type NewMonitor = {
  annotations: Array<NewAlertRuleAnnotation>;
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  collectionType?: InputMaybe<CollectionType>;
  labels: Array<NewAlertRuleLabel>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  spec: NewMonitorSpec;
};

export type NewMonitorCondition = {
  op: ThresholdOp;
  resolveSustain?: InputMaybe<Scalars['String']['input']>;
  resolveValue?: InputMaybe<Scalars['Float']['input']>;
  sustain: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type NewMonitorQuery = {
  queryDatasource: DatasourceType;
  queryExpression: Scalars['String']['input'];
};

export type NewMonitorSpec = {
  interval?: InputMaybe<Scalars['String']['input']>;
  notificationPolicySlug?: InputMaybe<Scalars['String']['input']>;
  query: NewMonitorQuery;
  schedule?: InputMaybe<NewSchedule>;
  seriesConditions: NewSeriesConditions;
  signalGrouping: NewSignalGrouping;
};

export type NewMutingRule = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /**
   * EndsAt is either a RFC3339 formatted string or `now`. In the latter case the current time is used
   * and the muting rule is immediately expired.
   */
  endsAt: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  matchers: Array<NewLabelMatcher>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** StarsAt is a RFC3339 formatted string. */
  startsAt: Scalars['String']['input'];
};

export type NewNotificationPolicyDestinationsBySeverity = {
  destinations: Array<NotificationPolicyDestinationInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  repeatInterval?: InputMaybe<Scalars['String']['input']>;
  severity: Scalars['String']['input'];
};

export type NewNotificationRoutes = {
  defaults: Array<NewNotifiersBySeverity>;
  /** V2 notification destinations by severity. */
  destinations?: InputMaybe<Array<NewNotificationPolicyDestinationsBySeverity>>;
  overrides: Array<NewNotificationRoutesOverride>;
};

export type NewNotificationRoutesOverride = {
  /** V2 notification destinations by severity. */
  destinations?: InputMaybe<Array<NewNotificationPolicyDestinationsBySeverity>>;
  matchers: Array<NewAlertRouteMatcher>;
  notifiers: Array<NewNotifiersBySeverity>;
};

export type NewNotificationRule = {
  name: Scalars['String']['input'];
  /** A list of receiver names. */
  receivers: Array<Scalars['String']['input']>;
};

export type NewNotifier = {
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type NewNotifiersBySeverity = {
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  notifierList: Array<NewNotifier>;
  repeatInterval?: InputMaybe<Scalars['String']['input']>;
  severity: Scalars['String']['input'];
};

export type NewRecordingRule = {
  executionGroup?: InputMaybe<Scalars['String']['input']>;
  expr: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  labels: Array<NewRecordingRuleLabel>;
  name: Scalars['String']['input'];
};

export type NewRecordingRuleLabel = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewResourcePool = {
  allocation: NewResourcePoolAllocation;
  matchRules?: InputMaybe<Array<LabelFilter>>;
  matchType: Match;
  name: Scalars['String']['input'];
  priorities?: InputMaybe<NewResourcePoolHighLowPriorities>;
};

export type NewResourcePoolAllocation = {
  fixedValues?: InputMaybe<Array<NewResourcePoolAllocationFixedValue>>;
  percentOfLicense?: InputMaybe<Scalars['Float']['input']>;
  priorityThresholds?: InputMaybe<Array<NewResourcePoolAllocationThresholds>>;
};

export type NewResourcePoolAllocationFixedValue = {
  license: ResourcePoolLicense;
  value: Scalars['Int']['input'];
};

export type NewResourcePoolAllocationThreshold = {
  fixedValue?: InputMaybe<Scalars['Int']['input']>;
  percentOfPoolAllocation?: InputMaybe<Scalars['Float']['input']>;
};

export type NewResourcePoolAllocationThresholds = {
  allPriorities?: InputMaybe<NewResourcePoolAllocationThreshold>;
  defaultAndLowPriority?: InputMaybe<NewResourcePoolAllocationThreshold>;
  license: ResourcePoolLicense;
  lowPriority?: InputMaybe<NewResourcePoolAllocationThreshold>;
};

export type NewResourcePoolHighLowPriorities = {
  highPriorityMatchRules?: InputMaybe<Array<LabelFilter>>;
  lowPriorityMatchRules?: InputMaybe<Array<LabelFilter>>;
};

export type NewResourcePools = {
  defaultPool?: InputMaybe<NewDefaultResourcePool>;
  pools?: InputMaybe<Array<NewResourcePool>>;
};

export type NewRollupRule = {
  addMetricTypeLabel: Scalars['Boolean']['input'];
  aggregationType: AggregationType;
  dropRaw: Scalars['Boolean']['input'];
  expansiveMatch: Scalars['Boolean']['input'];
  filters: Array<LabelFilter>;
  graphiteLabelPolicy?: InputMaybe<InputGraphiteLabelPolicy>;
  interval?: InputMaybe<Scalars['String']['input']>;
  labelPolicy?: InputMaybe<InputLabelPolicy>;
  labelReplace?: InputMaybe<Array<InputRollupRuleLabelReplace>>;
  metricName: Scalars['String']['input'];
  metricType: MetricType;
  mode: RollupRuleMode;
  name: Scalars['String']['input'];
  skipOnConflict?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  storagePolicy?: InputMaybe<InputStoragePolicy>;
};

export type NewSchedule = {
  timezone: Scalars['String']['input'];
  /**
   * Keyed by time.Weekday index in array (sunday -> saturday).
   * Entire field can be null to indicate no available ranges.
   * Individual days of the week can be null to indicate no ranges on that day.
   */
  weeklySchedule?: InputMaybe<Array<InputMaybe<NewScheduleDay>>>;
};

export type NewScheduleDay = {
  ranges: Array<NewTimeRange>;
};

export type NewSearchHistory = {
  name?: InputMaybe<Scalars['String']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  search: SearchHistoryQueryInput;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  type: SearchType;
};

export type NewSeriesConditions = {
  defaults: Array<NewSeverityCondition>;
  overrides: Array<NewConditionOverride>;
};

export type NewSeverityCondition = {
  conditionLevel: ConditionLevel;
  conditions: Array<NewMonitorCondition>;
};

export type NewSignalGrouping = {
  labelNames: Array<Scalars['String']['input']>;
  signalPerSeries: Scalars['Boolean']['input'];
};

export type NewTeam = {
  addRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Use `roles` instead. Only one of `roles` and `isSysAdmin` may be set. */
  isSysAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type NewThreadInput = {
  target: TargetInput;
  text: Scalars['String']['input'];
};

export type NewTimeRange = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

/** NotebooksListFilterInput is an input type that specifies filter criteria for listing notebooks. */
export type NotebooksListFilterInput = {
  /**
   * collectionRefs filters notebooks by collections.
   *
   * If multiple collectionRefs are provided, the results are "OR'd" together. If used with other
   * filters, then the filtered results are "AND'd" together.
   */
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  /**
   * slugs filters notebooks by slugs.
   *
   * If multiple slugs are provided, the results are "OR'd" together. If used with other
   * filters, then the filtered results are "AND'd" together.
   */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Queries for notification policies that are in-use by a set of monitors. The filters specify the set of monitors, and the
 * unique ordered notification policies used by those monitors are returned.
 * Repeated fields are ORed together and multiple fields are ANDed.
 */
export type NotificationPoliciesInUseFilters = {
  /** Get policies of monitors within any of the given collections. */
  collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Get policies of monitors by specific monitor slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get policies used by a monitor within any collection of the given teams. */
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationPoliciesPageFilters = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  onlyCustomerManaged?: InputMaybe<Scalars['Boolean']['input']>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationPolicyDestinationEmailTargetInput = {
  addresses: Array<Scalars['String']['input']>;
};

export type NotificationPolicyDestinationInput = {
  disableResolves?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<NotificationPolicyDestinationEmailTargetInput>;
  opsgenie?: InputMaybe<NotificationPolicyDestinationOpsgenieTargetInput>;
  pagerduty?: InputMaybe<NotificationPolicyDestinationPagerdutyTargetInput>;
  slack?: InputMaybe<NotificationPolicyDestinationSlackTargetInput>;
  victorops?: InputMaybe<NotificationPolicyDestinationVictoropsTargetInput>;
  webhook?: InputMaybe<NotificationPolicyDestinationWebhookTargetInput>;
};

export type NotificationPolicyDestinationOpsgenieTargetInput = {
  extConnectionSlug: Scalars['String']['input'];
};

export type NotificationPolicyDestinationPagerdutyTargetInput = {
  extConnectionSlug: Scalars['String']['input'];
};

export type NotificationPolicyDestinationSlackTargetInput = {
  channels: Array<Scalars['String']['input']>;
  extConnectionSlug: Scalars['String']['input'];
};

export type NotificationPolicyDestinationVictoropsTargetInput = {
  extConnectionSlug: Scalars['String']['input'];
  /** Deprecated: use routingKeys instead. If set, treated as a single-element routingKeys. */
  routingKey?: InputMaybe<Scalars['String']['input']>;
  routingKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A query parameter to append to a webhook URL. */
export type NotificationPolicyDestinationWebhookQueryParameterInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NotificationPolicyDestinationWebhookTargetInput = {
  extConnectionSlug: Scalars['String']['input'];
  /** Optional query parameters appended to the external connection webhook URL. */
  queryParameters?: InputMaybe<Array<NotificationPolicyDestinationWebhookQueryParameterInput>>;
};

export enum NumericFilterComparisonType {
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  UNKNOWN = 'UNKNOWN',
}

export type NumericFilterInput = {
  comparison: NumericFilterComparisonType;
  value: Scalars['Float']['input'];
};

export enum ObjectMergeRuleAction {
  DROP = 'DROP',
  KEEP = 'KEEP',
  REPLACE_KEY = 'REPLACE_KEY',
  SUPPRESS = 'SUPPRESS',
  UNKNOWN = 'UNKNOWN',
}

export type ObjectMergeRuleInput = {
  action: ObjectMergeRuleAction;
  description: Scalars['String']['input'];
  regex?: InputMaybe<Scalars['String']['input']>;
  replacement?: InputMaybe<Scalars['String']['input']>;
  separator?: InputMaybe<Scalars['String']['input']>;
  sourceLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<ObjectMergeRuleStatus>;
  suppressionRule?: InputMaybe<SuppressionMergeRuleInput>;
};

export enum ObjectMergeRuleStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum Ordering {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum OriginalMetricSource {
  DERIVED_METRIC = 'DERIVED_METRIC',
  RECORDING_RULE = 'RECORDING_RULE',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE',
}

export type PageDataInput = {
  pageName: Scalars['String']['input'];
  pageReferrer?: InputMaybe<Scalars['String']['input']>;
  pageTitle: Scalars['String']['input'];
  pageUrl: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};

/** Selects which PagerDuty Events API version to use. */
export enum PagerDutyEventsVersion {
  /** Use the legacy PagerDuty Events v1 API. */
  V1 = 'V1',
  /** Use the modern PagerDuty Events v2 API. */
  V2 = 'V2',
}

export enum ParserMode {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum PermissionAction {
  READ = 'READ',
  READWRITE = 'READWRITE',
  UNKNOWN = 'UNKNOWN',
  WRITE = 'WRITE',
}

export type PlaintextParserInput = {
  keepOriginal?: InputMaybe<Scalars['Boolean']['input']>;
  mode: ParserMode;
  name: Scalars['String']['input'];
  parser: LogParserInput;
};

export type PresentationConfigsInput = {
  overrides: Array<ComponentPresentationOverrideInput>;
};

export type PresentationDashboardInput = {
  /**
   *  Input Dashboard JSON along with the additional fields used to generate the component.
   * Can be used to edit the component
   */
  inputJSON?: InputMaybe<Scalars['JSONObject']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  serviceTemplateVar?: InputMaybe<Scalars['String']['input']>;
};

export type PresentationEligibilityInput = {
  allowedServiceSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoredServiceSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredDiscoverySlugs: Array<Scalars['String']['input']>;
  withoutDiscoverySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PresentationEventsInput = {
  /**
   * Event JSONs to render on panels and more details views.
   *
   * This field is only available if the ComponentPresentationType is "EVENTS"
   */
  eventJSONs?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
};

export type PutDocArtifactInput = {
  blob: Scalars['JSONObject']['input'];
  /** Optional expiration time. Null means never expires. */
  expireAt?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Key for the artifact.
   *
   * Must be unique or will overwrite existing artifact with the same key.
   * You can prefix the key with the special prefix "@user/" to make it private to the current user.
   * Private artifacts can only be written and read by the current user.
   */
  key: Scalars['String']['input'];
  labels?: InputMaybe<Array<LabelInput>>;
};

export type QueryDowntimesRequest = {
  activeOnly: Scalars['Boolean']['input'];
};

export type RPCInput = {
  endpointLabel: Scalars['String']['input'];
  errorCodes?: InputMaybe<Array<ErrorCodeDefInput>>;
  errorTypeLabel: Scalars['String']['input'];
};

export type ReadPresentationConfigInput = {
  slug: Scalars['String']['input'];
};

export type RecordingRulesFilters = {
  /**
   * If set, only rules with an executionGroup that contains this value will be returned. For legacy support, we will
   * search the attached collection slug (if there is one) instead. For rules with only execution group set, that is the only
   * field that is searched.
   */
  executionGroupContains?: InputMaybe<Scalars['String']['input']>;
  /** If set, only rules whose name field contains the string provided will be returned. The match is case insensitive */
  nameContains?: InputMaybe<Scalars['String']['input']>;
};

export type RegexParserInput = {
  regex: Scalars['String']['input'];
};

export type RelativeTimeFilterInput = {
  endRelativeOffsetSeconds?: InputMaybe<Scalars['Int']['input']>;
  startRelativeOffsetSeconds: Scalars['Int']['input'];
};

export type RemoveUserFromTeam = {
  teamID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type ReplaceFieldMappedValueInput = {
  defaultValue: Scalars['String']['input'];
  pairs: Array<ReplaceFieldMappedValuePairInput>;
  useDefault: Scalars['Boolean']['input'];
};

export type ReplaceFieldMappedValuePairInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum ReplaceFieldMode {
  HASH = 'HASH',
  MAPPED_VALUE = 'MAPPED_VALUE',
  STATIC_VALUE = 'STATIC_VALUE',
}

export type ReplaceFieldStaticValueInput = {
  value: Scalars['String']['input'];
};

export type ResendSignupInviteInput = {
  token: Scalars['String']['input'];
};

export enum ResourcePoolLicense {
  LICENSE_INVALID = 'LICENSE_INVALID',
  MATCHED_WRITES_HISTOGRAM = 'MATCHED_WRITES_HISTOGRAM',
  MATCHED_WRITES_STANDARD = 'MATCHED_WRITES_STANDARD',
  PERSISTED_CARDINALITY_HISTOGRAM = 'PERSISTED_CARDINALITY_HISTOGRAM',
  PERSISTED_CARDINALITY_STANDARD = 'PERSISTED_CARDINALITY_STANDARD',
  PERSISTED_WRITES_HISTOGRAM = 'PERSISTED_WRITES_HISTOGRAM',
  PERSISTED_WRITES_STANDARD = 'PERSISTED_WRITES_STANDARD',
}

export enum ResponderType {
  ID = 'ID',
  NAME = 'NAME',
  UNKNOWN = 'UNKNOWN',
  USERNAME = 'USERNAME',
}

export enum ResponseType {
  ESCALATION = 'ESCALATION',
  SCHEDULE = 'SCHEDULE',
  TEAM = 'TEAM',
  UNKNOWN = 'UNKNOWN',
  USER = 'USER',
}

export type RestoreEntityVersion = {
  id: Scalars['String']['input'];
};

export enum RollupRuleMode {
  ENABLED = 'ENABLED',
  PREVIEW = 'PREVIEW',
}

export enum RuleEvaluationErrorCode {
  CONFLICTING_MONITOR_LABELS = 'CONFLICTING_MONITOR_LABELS',
  CONFLICTING_RECORDING_LABELS = 'CONFLICTING_RECORDING_LABELS',
  DUPLICATE_SERIES = 'DUPLICATE_SERIES',
  INTERNAL = 'INTERNAL',
  INVALID = 'INVALID',
  LICENSE_EXCEEDED = 'LICENSE_EXCEEDED',
  RESOURCE_EXHAUSTED = 'RESOURCE_EXHAUSTED',
  TEMPLATE = 'TEMPLATE',
  TIMEOUT = 'TIMEOUT',
}

export enum RuleEvaluationRuleType {
  ALERTING = 'ALERTING',
  INVALID = 'INVALID',
  RECORDING = 'RECORDING',
}

export enum RuleEvaluationWindow {
  INVALID = 'INVALID',
  WINDOW_5M = 'WINDOW_5M',
  WINDOW_30M = 'WINDOW_30M',
}

export type SLIEndpointAvailabilityInput = {
  /** @deprecated replaced this with the identical field on the SLI */
  additionalPromFilters?: InputMaybe<Array<NewLabelMatcher>>;
  endpointsMonitored?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  successCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SLIEndpointLatencyInput = {
  /** @deprecated replaced this with the identical field on the SLI */
  additionalPromFilters?: InputMaybe<Array<NewLabelMatcher>>;
  endpointsMonitored?: InputMaybe<Array<Scalars['String']['input']>>;
  latencyBucket: Scalars['String']['input'];
};

export type SLIInput = {
  additionalPromFilters?: InputMaybe<Array<NewLabelMatcher>>;
  customDimensionLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  rawQueries?: InputMaybe<SLIQueriesInput>;
  templateData?: InputMaybe<SLITemplateDataInput>;
  timeSliceQueries?: InputMaybe<SLITimesliceQueriesInput>;
};

export type SLIQueriesInput = {
  badQuery?: InputMaybe<Scalars['String']['input']>;
  goodQuery?: InputMaybe<Scalars['String']['input']>;
  totalQuery: Scalars['String']['input'];
};

export type SLITemplateDataInput = {
  componentDiscoverySlug?: InputMaybe<Scalars['String']['input']>;
  endpointAvailability?: InputMaybe<SLIEndpointAvailabilityInput>;
  endpointLabel: Scalars['String']['input'];
  endpointLatency?: InputMaybe<SLIEndpointLatencyInput>;
  sourceService: CollectionRef;
  trackLensService?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SLITimesliceConditionInput = {
  op: ThresholdOp;
  value: Scalars['Float']['input'];
};

export type SLITimesliceQueriesInput = {
  condition?: InputMaybe<SLITimesliceConditionInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  sliceSize?: InputMaybe<TimesliceSize>;
};

export type SLOBurnRateDefinitionInput = {
  budget: Scalars['Float']['input'];
  labels?: InputMaybe<Array<LabelInput>>;
  severity?: InputMaybe<ConditionLevel>;
  window: Scalars['String']['input'];
};

export type SLODefinitionInput = {
  burnRateAlertingConfig?: InputMaybe<Array<SLOBurnRateDefinitionInput>>;
  enableBurnRateAlerting?: InputMaybe<Scalars['Boolean']['input']>;
  objective: Scalars['Float']['input'];
  timeWindow?: InputMaybe<SLOReportingWindowInput>;
};

export type SLOListFilterInput = {
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** If set, only SLOs whose name or slug contains the specified string will be returned. */
  nameOrSlugContains?: InputMaybe<Scalars['String']['input']>;
  notificationPolicySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SLOQueriesInput = {
  slo: UpdateSLOInput;
};

export type SLOReportingWindowInput = {
  duration: Scalars['String']['input'];
};

export enum SLOType {
  ENDPOINT_AVAILABILITY = 'ENDPOINT_AVAILABILITY',
  LATENCY = 'LATENCY',
}

/** Input used to save a collection homepage. */
export type SaveCollectionHomepageInput = {
  collectionSlug: Scalars['String']['input'];
  links?: InputMaybe<Array<InputMaybe<LinkInput>>>;
};

export type SaveDashboardInput = {
  /** Collection containing this dashboard */
  collectionSlug: Scalars['String']['input'];
  /**
   * Type of the collection containing the dashboard. Optional for backwards compatibility. Defaults to SIMPLE if not
   * specified.
   */
  collectionType?: InputMaybe<CollectionType>;
  dashboardJSON: Scalars['JSONObject']['input'];
  labels?: InputMaybe<Array<LabelInput>>;
  /** Dashboard name. Must be unique within a collection. */
  name: Scalars['String']['input'];
  /** Slug of dashboard to create or update. A new dashboard will be created if this is unset or empty. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Input used to save a team homepage. */
export type SaveTeamHomepageInput = {
  links?: InputMaybe<Array<InputMaybe<LinkInput>>>;
  teamSlug: Scalars['String']['input'];
};

export enum SavedTraceSearchColumn {
  CREATED_AT = 'CREATED_AT',
  NAME = 'NAME',
}

export type SavedTraceSearchOrdering = {
  column: SavedTraceSearchColumn;
  order: Ordering;
};

export type SavedTraceSearchQueryInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByStartsWith?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<SavedTraceSearchOrdering>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ScalingDirection {
  DOWN = 'DOWN',
  UP = 'UP',
}

export type ScopeFilterInput = {
  spanScopes?: InputMaybe<Array<SpanFilterInput>>;
};

export type SearchHistoryQueryInput = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
  summaryFields?: InputMaybe<Array<Scalars['String']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchQuery = {
  /** A list of entity kinds to search for. If not set, all kinds are matched. */
  kindFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum number of results to return. Defaults to 25 if not set. */
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  /** The string to search for */
  query?: InputMaybe<Scalars['String']['input']>;
  /** If true, also search within additional fields like dashboard queries. Defaults to false. */
  searchEntityBodies?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SearchType {
  DATAQUERY = 'DATAQUERY',
  INVALID = 'INVALID',
  LOGGING = 'LOGGING',
  TIMELINE = 'TIMELINE',
}

export type SemanticSearchQuery = {
  /** A list of entity kinds to filter results by. If not set, all kinds are matched. */
  kindFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum number of results to return. Defaults to 25 if not set. */
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum similarity score (0.0-1.0). Default: 0.0 (include all). */
  minSimilarity?: InputMaybe<Scalars['Float']['input']>;
  /** The natural language query to search for semantically similar entities. */
  query: Scalars['String']['input'];
};

export type SendTestNotificationInput = {
  monitorSlug: Scalars['String']['input'];
  severity: ConditionLevel;
  signalLabels?: InputMaybe<Array<LabelInput>>;
};

export type ServiceToTracingServiceAttributeInput = {
  serviceDerivedNames: Array<Scalars['String']['input']>;
};

export type ServicesFilter = {
  discoverySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ServicesInput = {
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ShortenMessageRequest = {
  message: Scalars['String']['input'];
};

export type SpanFilterInput = {
  duration?: InputMaybe<DurationFilterInput>;
  error?: InputMaybe<BoolFilterInput>;
  inCriticalPath?: InputMaybe<BoolFilterInput>;
  isRootSpan?: InputMaybe<BoolFilterInput>;
  leafError?: InputMaybe<BoolFilterInput>;
  matchType?: InputMaybe<SpanFilterMatchType>;
  operation?: InputMaybe<StringFilterInput>;
  parentOperation?: InputMaybe<StringFilterInput>;
  parentService?: InputMaybe<StringFilterInput>;
  service?: InputMaybe<StringFilterInput>;
  spanCount?: InputMaybe<CountFilterInput>;
  tags?: InputMaybe<Array<TagFilterInput>>;
};

export enum SpanFilterMatchType {
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE',
  UNKNOWN = 'UNKNOWN',
}

export type StringFilterInput = {
  inValues?: InputMaybe<Array<Scalars['String']['input']>>;
  match: StringFilterMatchType;
  value: Scalars['String']['input'];
};

export enum StringFilterMatchType {
  EXACT = 'EXACT',
  EXACT_NEGATION = 'EXACT_NEGATION',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  REGEX = 'REGEX',
  REGEX_NEGATION = 'REGEX_NEGATION',
  UNKNOWN = 'UNKNOWN',
}

export type StringNormalizationInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  sanitizePatterns?: InputMaybe<Array<Scalars['String']['input']>>;
  source: Array<Scalars['String']['input']>;
  valueMap?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitChangeRequestInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  requestType: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SuppressionMergeRuleInput = {
  /** @deprecated Prefer DiscoveryConfigsInput.SuppressionExemptServices instead */
  exceptionServiceNames?: InputMaybe<Array<Scalars['String']['input']>>;
  suppressedDiscoveryComponentSlug: Scalars['String']['input'];
};

export enum SyntheticTestHttpMethod {
  GET = 'GET',
}

export type SyntheticTestHttpTestConfigInput = {
  method: SyntheticTestHttpMethod;
  statusCodeAssertions?: InputMaybe<Array<SyntheticTestStatusCodeAssertionInput>>;
  url: Scalars['String']['input'];
};

export enum SyntheticTestLocation {
  GCP_US_LOS_ANGELES = 'GCP_US_LOS_ANGELES',
}

export enum SyntheticTestStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type SyntheticTestStatusCodeAssertionInput = {
  operator: SyntheticTestStatusCodeAssertionOperator;
  target: Scalars['Int']['input'];
};

export enum SyntheticTestStatusCodeAssertionOperator {
  EQUALS = 'EQUALS',
}

export enum SyntheticTestType {
  HTTP = 'HTTP',
}

export type TagFilterInput = {
  key: Scalars['String']['input'];
  numericValue?: InputMaybe<NumericFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type TargetInput = {
  reference: Scalars['String']['input'];
  type: TargetType;
};

export enum TargetType {
  AGGREGATION_RULE = 'AGGREGATION_RULE',
  ALERT = 'ALERT',
  CHANGE_EVENT = 'CHANGE_EVENT',
  DROP_RULE = 'DROP_RULE',
  METRIC_LABEL = 'METRIC_LABEL',
  METRIC_NAME = 'METRIC_NAME',
  MONITOR = 'MONITOR',
  PANEL_ANNOTATION = 'PANEL_ANNOTATION',
  RECORDING_RULE = 'RECORDING_RULE',
  TESTING = 'TESTING',
  UNKNOWN = 'UNKNOWN',
}

export type TargetsListInput = {
  targets: Array<TargetInput>;
};

export enum TelemetryType {
  LOGS = 'LOGS',
  METRICS = 'METRICS',
  TRACES = 'TRACES',
  UNKNOWN = 'UNKNOWN',
}

export type TemplateInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  value: TemplateValueInput;
};

export type TemplateValueInput = {
  labelValues: LabelValuesInput;
};

export type TestFieldParserInput = {
  fieldParser: LogFieldParserInput;
  testInput: Scalars['String']['input'];
};

export type TestParserInput = {
  parser: LogParserInput;
  testInput: Scalars['String']['input'];
};

export type ThreadsListInput = {
  target: TargetInput;
};

export enum ThresholdOp {
  EQ = 'EQ',
  EXISTS = 'EXISTS',
  GEQ = 'GEQ',
  GT = 'GT',
  INVALID = 'INVALID',
  LEQ = 'LEQ',
  LT = 'LT',
  NEQ = 'NEQ',
  NOT_EXISTS = 'NOT_EXISTS',
  SIGNAL_NOT_EXISTS = 'SIGNAL_NOT_EXISTS',
}

export type TimeFilterInput = {
  between?: InputMaybe<BetweenTimeFilterInput>;
  close?: InputMaybe<CloseToTimeFilterInput>;
  relative?: InputMaybe<RelativeTimeFilterInput>;
};

export enum TimesliceSize {
  FiveMinutes = 'FiveMinutes',
  OneMinute = 'OneMinute',
}

export type TimestampNormalizationInput = {
  source: Array<Scalars['String']['input']>;
};

export type TraceAggregationFocusInput = {
  criticalPathOnly?: InputMaybe<Scalars['Boolean']['input']>;
  terminalErrorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TraceAggregationGroupByKeyInput = {
  type: TraceAggregationGroupByType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum TraceAggregationGroupByType {
  OP = 'OP',
  SVC = 'SVC',
  TAG = 'TAG',
  UNKNOWN = 'UNKNOWN',
}

export type TraceAggregationOptionsInput = {
  focus?: InputMaybe<TraceAggregationFocusInput>;
  shape?: InputMaybe<TraceAggregationShapeInput>;
};

export type TraceAggregationShapeInput = {
  groupBy: Array<TraceAggregationGroupByKeyInput>;
};

export enum TraceBehaviorAssignmentType {
  MAIN = 'MAIN',
  OVERRIDE = 'OVERRIDE',
  REMOVED = 'REMOVED',
  UNKNOWN = 'UNKNOWN',
}

export type TraceBehaviorBaselineOptionsInput = {
  baseHeadSampleRate: Scalars['Float']['input'];
  baseTailSampleRate: Scalars['Float']['input'];
  errorSampleOptions?: InputMaybe<TraceBehaviorErrorSampleOptionsInput>;
  fastSampleOptions?: InputMaybe<TraceBehaviorFastSampleOptionsInput>;
  largeTraceSampleOptions?: InputMaybe<TraceBehaviorLargeTraceSampleOptionsInput>;
  slowSampleOptions?: InputMaybe<TraceBehaviorSlowSampleOptionsInput>;
  smallTraceSampleOptions?: InputMaybe<TraceBehaviorSmallTraceSampleOptionsInput>;
};

export type TraceBehaviorErrorSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
};

export type TraceBehaviorFastSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  maxDurationSeconds: Scalars['Float']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
};

export type TraceBehaviorLargeTraceSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
  spanCountThreshold: Scalars['Int']['input'];
};

export type TraceBehaviorMainAssignmentInput = {
  behavior: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  dataset: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type TraceBehaviorOverrideAssignmentInput = {
  behavior: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  dataset: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum TraceBehaviorSamplingType {
  HIGH_VALUE = 'HIGH_VALUE',
  LOW_VALUE = 'LOW_VALUE',
  UNKNOWN = 'UNKNOWN',
}

export type TraceBehaviorSlowSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  minDurationSeconds: Scalars['Float']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
};

export type TraceBehaviorSmallTraceSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
  spanCountThreshold: Scalars['Int']['input'];
};

export type TraceDatasetConfigurationInput = {
  filter: TraceSearchFilterInput;
};

export type TraceDatasetEnhancementsInput = {
  metricsTimeRange?: InputMaybe<TimeFilterInput>;
};

export type TraceFilterInput = {
  duration?: InputMaybe<DurationFilterInput>;
  error?: InputMaybe<BoolFilterInput>;
};

export type TraceJaegerRemoteSamplingStrategiesListFilterInput = {
  nameOrServiceContains?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceNames?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TraceMetricsGroupByInput = {
  key: TraceMetricsGroupByKeyInput;
  label: Scalars['String']['input'];
};

export type TraceMetricsGroupByKeyInput = {
  namedKey?: InputMaybe<Scalars['String']['input']>;
  type: TraceMetricsGroupByKeyType;
};

export enum TraceMetricsGroupByKeyType {
  OPERATION = 'OPERATION',
  PARENT_OPERATION = 'PARENT_OPERATION',
  PARENT_SERVICE = 'PARENT_SERVICE',
  ROOT_OPERATION = 'ROOT_OPERATION',
  ROOT_SERVICE = 'ROOT_SERVICE',
  SERVICE = 'SERVICE',
  TAG = 'TAG',
  UNKNOWN = 'UNKNOWN',
}

export type TraceMetricsRulesListFilterInput = {
  metricNames?: InputMaybe<Array<Scalars['String']['input']>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TraceSearchFilterInput = {
  scope?: InputMaybe<ScopeFilterInput>;
  span?: InputMaybe<Array<SpanFilterInput>>;
  trace?: InputMaybe<TraceFilterInput>;
};

export type TraceSearchInput = {
  aggregationOptions?: InputMaybe<TraceAggregationOptionsInput>;
  criteria: TraceSearchFilterInput;
  criticalPathMode?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsGroupBy?: InputMaybe<Scalars['String']['input']>;
  time: TimeFilterInput;
};

export type TraceTopTagInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TracingServiceAttributeToServiceInput = {
  tracingServiceAttribute: Array<Scalars['String']['input']>;
};

export type TransformInput = {
  regex: Scalars['String']['input'];
  replacement: Scalars['String']['input'];
};

export enum UITheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  SYSTEM = 'SYSTEM',
  UNKNOWN = 'UNKNOWN',
}

export type UIThemeInput = {
  uiTheme: UITheme;
};

export type UpdateAlertReceiver = {
  email?: InputMaybe<Array<NewAlertReceiverEmailConfig>>;
  /** Deprecated, use slug when possible */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  opsgenie?: InputMaybe<Array<NewAlertReceiverOpsGenieConfig>>;
  pagerduty?: InputMaybe<Array<NewAlertReceiverPagerdutyConfig>>;
  slack?: InputMaybe<Array<NewAlertReceiverSlackConfig>>;
  slug?: InputMaybe<Scalars['ID']['input']>;
  victorOps?: InputMaybe<Array<NewAlertReceiverVictorOpsConfig>>;
  webhook?: InputMaybe<Array<NewAlertReceiverWebhookConfig>>;
};

export type UpdateCollection = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Optional slug of notification policy used by this collection */
  policySlug?: InputMaybe<Scalars['String']['input']>;
  /** Required slug for the collection to update. */
  slug: Scalars['String']['input'];
  team_slug?: InputMaybe<Scalars['String']['input']>;
  /** Optional type of collection to update. If unspecified, updates a SIMPLE collection. */
  type?: InputMaybe<CollectionType>;
};

export type UpdateCommentInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomComponentInput = {
  dashboard: Scalars['JSONObject']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceTemplateVar?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type UpdateDashboardAIDescriptionStatusInput = {
  /** The slug of the dashboard */
  slug: Scalars['String']['input'];
  /** The new status for the AI description */
  status: AIDescriptionStatus;
};

export type UpdateDatasetInput = {
  description: Scalars['String']['input'];
  logConfiguration?: InputMaybe<LogDatasetConfigurationInput>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  traceConfiguration?: InputMaybe<TraceDatasetConfigurationInput>;
};

export type UpdateDerivedLabelInput = {
  /** DerivedLabelSpanTag is used to map span tags to derived labels. */
  derivedLabelSpanTag?: InputMaybe<DerivedLabelSpanTagInput>;
  /** An optional description of the derived label. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** This field specifies the action taken when there's a metric label with the same name as this derived label. */
  existingLabelPolicy?: InputMaybe<DerivedLabelPolicy>;
  /** The name of the derived label. */
  labelName: Scalars['String']['input'];
  metricLabel?: InputMaybe<MetricLabelInput>;
  /** The name of the derived label. */
  name: Scalars['String']['input'];
  /** The unique slug of the derived label. */
  slug: Scalars['String']['input'];
};

export type UpdateDiscoveryInput = {
  /** Discovery config for events. */
  events?: InputMaybe<EventDiscoveryInput>;
  /** Discovery config for metrics. */
  metrics?: InputMaybe<MetricsDiscoveryInput>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type UpdateDropRule = {
  dropNanValue?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Array<LabelFilter>;
  mode: DropRuleMode;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  valueBasedDrop?: InputMaybe<InputDropRuleValueBasedDrop>;
};

/**
 * Exactly one of slack, pagerduty, webhook, victorops, opsgenie, or cloudflare must be
 * provided.
 *
 * This mirrors the ExternalConnection response shape.
 */
export type UpdateExternalConnectionInput = {
  cloudflare?: InputMaybe<ExternalConnectionCloudflareConfigInput>;
  name: Scalars['String']['input'];
  opsgenie?: InputMaybe<ExternalConnectionOpsGenieConfigInput>;
  pagerduty?: InputMaybe<ExternalConnectionPagerDutyConfigInput>;
  slack?: InputMaybe<ExternalConnectionSlackConfigInput>;
  slug: Scalars['ID']['input'];
  victorops?: InputMaybe<ExternalConnectionVictorOpsConfigInput>;
  webhook?: InputMaybe<ExternalConnectionWebhookConfigInput>;
};

export type UpdateFavoriteInput = {
  entityType: FavoriteEntityType;
  isFavorite: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};

export type UpdateGlobalFiltersInput = {
  filters: Array<TemplateInput>;
};

export type UpdateLinkTemplateInput = {
  name: Scalars['String']['input'];
  slug: Scalars['ID']['input'];
  urlTemplate: Scalars['String']['input'];
};

export type UpdateLogControlConfigInput = {
  createIfMissing: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  logControlConfig: LogControlConfigInput;
};

export type UpdateLogIngestConfigInput = {
  createIfMissing: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  logIngestConfig: LogIngestConfigInput;
};

export type UpdateLogLookupTableInput = {
  createIfMissing: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  logLookupTable: LogLookupTableInput;
};

export type UpdateLogRetentionConfigInput = {
  createIfMissing: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  logRetentionConfig: LogRetentionConfigInput;
  slug: Scalars['String']['input'];
};

export type UpdateMappingRule = {
  aggregationPolicy?: InputMaybe<InputMappingRuleAggregationPolicy>;
  drop: Scalars['Boolean']['input'];
  filters: Array<LabelFilter>;
  mode: MappingRuleMode;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type UpdateNotebookInput = {
  /** Collection containing this notebook */
  collectionSlug: Scalars['String']['input'];
  /**
   * Type of the collection containing the notebook. Optional for backwards compatibility. Defaults to SIMPLE if not
   * specified.
   */
  collectionType?: InputMaybe<CollectionType>;
  /** Notebook name. Must be unique within a collection. */
  name: Scalars['String']['input'];
  /** Notebook JSON configuration. */
  notebookJSON: Scalars['JSONObject']['input'];
  /** Slug of notebook to update. */
  slug: Scalars['String']['input'];
};

export type UpdatePresentationInput = {
  dashboard?: InputMaybe<PresentationDashboardInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  eligibility?: InputMaybe<PresentationEligibilityInput>;
  events?: InputMaybe<PresentationEventsInput>;
  name: Scalars['String']['input'];
  numPanelsToDisplay?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};

export type UpdateRecordingRule = {
  executionGroup?: InputMaybe<Scalars['String']['input']>;
  expr: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  interval: Scalars['String']['input'];
  labels: Array<NewRecordingRuleLabel>;
  name: Scalars['String']['input'];
};

export type UpdateRollupRule = {
  addMetricTypeLabel: Scalars['Boolean']['input'];
  aggregationType: AggregationType;
  dropRaw: Scalars['Boolean']['input'];
  expansiveMatch: Scalars['Boolean']['input'];
  filters: Array<LabelFilter>;
  graphiteLabelPolicy?: InputMaybe<InputGraphiteLabelPolicy>;
  interval?: InputMaybe<Scalars['String']['input']>;
  labelPolicy?: InputMaybe<InputLabelPolicy>;
  labelReplace?: InputMaybe<Array<InputRollupRuleLabelReplace>>;
  metricName: Scalars['String']['input'];
  metricType: MetricType;
  mode: RollupRuleMode;
  name: Scalars['String']['input'];
  skipOnConflict?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  storagePolicy?: InputMaybe<InputStoragePolicy>;
};

export type UpdateSLOAIDescriptionStatusInput = {
  /** The slug of the SLO */
  slug: Scalars['String']['input'];
  /** The new status for the AI description */
  status: AIDescriptionStatus;
};

export type UpdateSLOInput = {
  annotations?: InputMaybe<Array<AnnotationInput>>;
  collectionSlug: Scalars['String']['input'];
  collectionType: CollectionType;
  definition: SLODefinitionInput;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<LabelInput>>;
  name: Scalars['String']['input'];
  notificationPolicySlug?: InputMaybe<Scalars['String']['input']>;
  signalGrouping?: InputMaybe<NewSignalGrouping>;
  sli: SLIInput;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSavedTraceSearchInput = {
  name: Scalars['String']['input'];
  slug: Scalars['ID']['input'];
};

export type UpdateSearchHistoryInput = {
  search: NewSearchHistory;
};

export type UpdateServiceAttribute = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationPolicyId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  team?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSyntheticGlobalVariableInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** When true, validates the request without persisting. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Optional on update. Omitting it is a metadata-only change. */
  secretValue?: InputMaybe<Scalars['String']['input']>;
  secure: Scalars['Boolean']['input'];
  slug: Scalars['ID']['input'];
};

export type UpdateSyntheticTestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  httpTest?: InputMaybe<SyntheticTestHttpTestConfigInput>;
  intervalSecs: Scalars['Int']['input'];
  labels?: InputMaybe<Array<LabelInput>>;
  locations: Array<SyntheticTestLocation>;
  name: Scalars['String']['input'];
  slug: Scalars['ID']['input'];
  status: SyntheticTestStatus;
  testType: SyntheticTestType;
};

export type UpdateTeam = {
  addedRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Deprecated. Use `addedRoles` and `removedRoles` instead. Only one of `isSysAdmin` and `addedRoles` or `removedRoles` may be set. */
  isSysAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  removedRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateThreadInput = {
  id: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTraceBehaviorConfigInput = {
  baselineBehaviorSlug?: InputMaybe<Scalars['String']['input']>;
  datasetPriorities?: InputMaybe<Array<Scalars['String']['input']>>;
  mainBehaviorAssignments?: InputMaybe<Array<TraceBehaviorMainAssignmentInput>>;
  overrideBehaviorAssignments?: InputMaybe<Array<TraceBehaviorOverrideAssignmentInput>>;
  previewBehaviorAssignments?: InputMaybe<Array<TraceBehaviorOverrideAssignmentInput>>;
  version: Scalars['Int']['input'];
};

export type UpdateTraceBehaviorInput = {
  baseHeadSampleRate?: InputMaybe<Scalars['Float']['input']>;
  baseTailSampleRate?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorSampleOptions?: InputMaybe<TraceBehaviorErrorSampleOptionsInput>;
  fastSampleOptions?: InputMaybe<TraceBehaviorFastSampleOptionsInput>;
  largeTraceSampleOptions?: InputMaybe<TraceBehaviorLargeTraceSampleOptionsInput>;
  name: Scalars['String']['input'];
  slowSampleOptions?: InputMaybe<TraceBehaviorSlowSampleOptionsInput>;
  slug: Scalars['ID']['input'];
  smallTraceSampleOptions?: InputMaybe<TraceBehaviorSmallTraceSampleOptionsInput>;
};

export type UpdateTraceMetricsRuleInput = {
  groupBys?: InputMaybe<Array<TraceMetricsGroupByInput>>;
  histogramBucketsSeconds: Array<Scalars['Float']['input']>;
  metricLabels: Array<LabelInput>;
  metricName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scopeFilter?: InputMaybe<ScopeFilterInput>;
  slug: Scalars['ID']['input'];
  traceFilter: TraceSearchFilterInput;
};

export type UpdateTraceTopTagsInput = {
  data: Array<TraceTopTagInput>;
  version: Scalars['Int']['input'];
};

export type UpdatedMonitor = {
  annotations: Array<NewAlertRuleAnnotation>;
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  collectionType?: InputMaybe<CollectionType>;
  labels: Array<NewAlertRuleLabel>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  spec: NewMonitorSpec;
};

/** UpsertCollectionLinksInput is an input type that specifies a list of collection links to create or update. */
export type UpsertCollectionLinksInput = {
  collectionLinks: Array<CollectionLinkInput>;
};

export type UserSettingsInput = {
  darkMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSettingsValueInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Any']['input']>;
};

export enum UserState {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  INVITED = 'INVITED',
  PENDING = 'PENDING',
  SYNCED = 'SYNCED',
  UNKNOWN = 'UNKNOWN',
}

export enum UserType {
  ACCOUNT = 'ACCOUNT',
  SERVICE_ACCOUNT = 'SERVICE_ACCOUNT',
  UNKNOWN = 'UNKNOWN',
}

export enum ValidationStatus {
  INVALID = 'INVALID',
  UNKNOWN = 'UNKNOWN',
  VALID = 'VALID',
}

export type ValueDefinitionInput = {
  /** The filters that define the constructed label. */
  filters?: InputMaybe<Array<DerivedLabelFilterInput>>;
  /** The value of the constructed label. */
  value: Scalars['String']['input'];
};

export enum XRayNodeType {
  METRIC_NAME = 'METRIC_NAME',
  QUERY = 'QUERY',
}

export type metricMetadataFilterListinput = {
  metricNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter metrics by name substring (case-insensitive). */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Filter to metadata updated after this time. */
  updatedAfter?: InputMaybe<Scalars['Time']['input']>;
};

export type GetCurrentUserVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUser = { me: { id: string; email: string; isAdmin: boolean } };

export type GetFeatureFlagsV2Variables = Exact<{
  flags: Array<FeatureFlagRequest> | FeatureFlagRequest;
}>;

export type GetFeatureFlagsV2 = {
  featureFlagsV2: Array<{
    key: string;
    value: { boolValue: boolean } | { intValue: number } | { stringValue: string };
  }>;
};

export type GetGatewayConfigsVariables = Exact<{ [key: string]: never }>;

export type GetGatewayConfigs = {
  gatewayConfigs: {
    returnedSeriesLimit: number;
    returnedDatapointsLimit: number;
    tracingUIEnabled: boolean;
    collectionsAccess: string;
    serviceUIEnabled: boolean;
    sloUIEnabled: boolean;
    enableExternalServiceConfig: boolean;
    enableMetricsDDX: boolean;
    alertEntityUIEnabled: boolean;
    aiGatewayEnabled: boolean;
    agentInvestigationsEnabled: boolean;
  };
  tenant: { graphiteEnabled: boolean; tenantConfiguration: { scrapeInterval: string } };
};

export type ServiceViewAttributes = {
  service: {
    name: string;
    derivedName: string;
    slug: string;
    description: string;
    policy: { name: string; slug: string } | null;
    team: { name: string; slug: string } | null;
  };
  labelsConfig: Array<{
    name: string;
    traces: { nameMapping: string | null; valueMapping: Array<{ name: string; values: Array<string> }> | null } | null;
    events: { nameMapping: string | null; valueMapping: Array<{ name: string; values: Array<string> }> | null } | null;
  }> | null;
  components: Array<{ name: string; slug: string; moreDetailsJSON: any | null; panelJSONs: Array<any> | null }> | null;
};

export type ServiceOverviewVariables = Exact<{
  serviceSlug: Scalars['String']['input'];
}>;

export type ServiceOverview = {
  serviceView: {
    service: {
      name: string;
      derivedName: string;
      slug: string;
      description: string;
      policy: { name: string; slug: string } | null;
      team: { name: string; slug: string } | null;
    };
    labelsConfig: Array<{
      name: string;
      traces: {
        nameMapping: string | null;
        valueMapping: Array<{ name: string; values: Array<string> }> | null;
      } | null;
      events: {
        nameMapping: string | null;
        valueMapping: Array<{ name: string; values: Array<string> }> | null;
      } | null;
    }> | null;
    components: Array<{
      name: string;
      slug: string;
      moreDetailsJSON: any | null;
      panelJSONs: Array<any> | null;
    }> | null;
  } | null;
};

export type ListMonitorsQueryVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: MonitorsV2Filters;
}>;

export type ListMonitorsQuery = {
  monitorsV2: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    monitors: Array<{
      slug: string;
      name: string;
      isFavorite: boolean;
      exportFormat: ExportFormat;
      spec: { signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean } };
      policy: { explicitReference: boolean; policy: { name: string; slug: string } } | null;
      collection: {
        name: string;
        type: CollectionType;
        slug: string;
        nullableTeam: { id: string; slug: string; name: string } | null;
      };
      state: {
        state: AlertState;
        signals: Array<{
          state: AlertState;
          series: Array<{ status: { status: AlertState; startedAt: string | null } }> | null;
          labels: Array<{ name: string; value: string }> | null;
        }> | null;
      };
    }>;
  };
};

export const ServiceViewAttributes = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ServiceViewAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ServiceView' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'service' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'derivedName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labelsConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'traces' },
                  name: { kind: 'Name', value: 'tracing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nameMapping' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'valueMapping' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nameMapping' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'valueMapping' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'moreDetailsJSON' } },
                { kind: 'Field', name: { kind: 'Name', value: 'panelJSONs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceViewAttributes, unknown>;
export const GetCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUser, GetCurrentUserVariables>;
export const GetFeatureFlagsV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFeatureFlagsV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'flags' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'FeatureFlagRequest' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlagsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'flags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'flags' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BoolValue' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'boolValue' },
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StringValue' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'stringValue' },
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IntValue' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'intValue' },
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeatureFlagsV2, GetFeatureFlagsV2Variables>;
export const GetGatewayConfigsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGatewayConfigs' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gatewayConfigs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'returnedSeriesLimit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnedDatapointsLimit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tracingUIEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collectionsAccess' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceUIEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sloUIEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enableExternalServiceConfig' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enableMetricsDDX' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alertEntityUIEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aiGatewayEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentInvestigationsEnabled' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'graphiteEnabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantConfiguration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'scrapeInterval' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetGatewayConfigs, GetGatewayConfigsVariables>;
export const ServiceOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ServiceOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'serviceSlug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'serviceSlug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ServiceViewAttributes' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ServiceViewAttributes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ServiceView' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'service' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'derivedName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labelsConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'traces' },
                  name: { kind: 'Name', value: 'tracing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nameMapping' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'valueMapping' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nameMapping' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'valueMapping' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'components' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'moreDetailsJSON' } },
                { kind: 'Field', name: { kind: 'Name', value: 'panelJSONs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ServiceOverview, ServiceOverviewVariables>;
export const ListMonitorsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListMonitorsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MonitorsV2Filters' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'monitorsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'monitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spec' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'signalGrouping' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'labelNames' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'signalPerSeries' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'policy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'explicitReference' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nullableTeam' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'exportFormat' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'state' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'signals' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'series' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'status' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'labels' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListMonitorsQuery, ListMonitorsQueryVariables>;
export const SchemaTypenames = {
  Alert: 'Alert',
  AlertAnalysisAggregationBucket: 'AlertAnalysisAggregationBucket',
  AlertAnalysisAlert: 'AlertAnalysisAlert',
  AlertAnalysisMuteActionHistoryEntry: 'AlertAnalysisMuteActionHistoryEntry',
  AlertAnalysisNotifierHistoryEntry: 'AlertAnalysisNotifierHistoryEntry',
  AlertAnalysisOwnershipContext: 'AlertAnalysisOwnershipContext',
  AlertAnalysisSeverityChangeHistoryEntry: 'AlertAnalysisSeverityChangeHistoryEntry',
  AlertAnalysisSloMetadata: 'AlertAnalysisSloMetadata',
  AlertEvent: 'AlertEvent',
  AlertEventConnection: 'AlertEventConnection',
  AlertReceiver: 'AlertReceiver',
  AlertReceiverEmailConfig: 'AlertReceiverEmailConfig',
  AlertReceiverHTTPConfig: 'AlertReceiverHTTPConfig',
  AlertReceiverHTTPConfigBasicAuth: 'AlertReceiverHTTPConfigBasicAuth',
  AlertReceiverHTTPConfigTLSConfig: 'AlertReceiverHTTPConfigTLSConfig',
  AlertReceiverNotifierBaseConfig: 'AlertReceiverNotifierBaseConfig',
  AlertReceiverOpsGenieConfig: 'AlertReceiverOpsGenieConfig',
  AlertReceiverOpsGenieConfigResponder: 'AlertReceiverOpsGenieConfigResponder',
  AlertReceiverPagerdutyConfig: 'AlertReceiverPagerdutyConfig',
  AlertReceiverPagerdutyConfigImage: 'AlertReceiverPagerdutyConfigImage',
  AlertReceiverPagerdutyConfigLink: 'AlertReceiverPagerdutyConfigLink',
  AlertReceiverSlackConfig: 'AlertReceiverSlackConfig',
  AlertReceiverSlackConfigAction: 'AlertReceiverSlackConfigAction',
  AlertReceiverSlackConfigConfirmField: 'AlertReceiverSlackConfigConfirmField',
  AlertReceiverSlackConfigField: 'AlertReceiverSlackConfigField',
  AlertReceiverVictorOpsConfig: 'AlertReceiverVictorOpsConfig',
  AlertReceiverWebhookConfig: 'AlertReceiverWebhookConfig',
  AlertReceivers: 'AlertReceivers',
  AlertRouteMatcher: 'AlertRouteMatcher',
  AlertRuleLabel: 'AlertRuleLabel',
  AlertStatus: 'AlertStatus',
  AlertsConnection: 'AlertsConnection',
  AllDashboardsConnection: 'AllDashboardsConnection',
  AnalyzeAlertsAggregateResponse: 'AnalyzeAlertsAggregateResponse',
  AnalyzeAlertsListResponse: 'AnalyzeAlertsListResponse',
  Annotation: 'Annotation',
  Attribute: 'Attribute',
  AttributeConnection: 'AttributeConnection',
  Attributes: 'Attributes',
  BetweenTimeFilter: 'BetweenTimeFilter',
  BoolFilter: 'BoolFilter',
  BoolValue: 'BoolValue',
  BulkCreateThreadsResult: 'BulkCreateThreadsResult',
  ChronosphereLoggingConfig: 'ChronosphereLoggingConfig',
  CloseToTimeFilter: 'CloseToTimeFilter',
  Collection: 'Collection',
  CollectionDashboardConnection: 'CollectionDashboardConnection',
  CollectionDashboardLink: 'CollectionDashboardLink',
  CollectionHomepage: 'CollectionHomepage',
  CollectionLink: 'CollectionLink',
  CollectionLinksConnection: 'CollectionLinksConnection',
  CollectionMonitorLink: 'CollectionMonitorLink',
  CollectionsConnection: 'CollectionsConnection',
  CommandCenterAlertStatus: 'CommandCenterAlertStatus',
  CommandCenterGroup: 'CommandCenterGroup',
  CommandCenterGroupConnection: 'CommandCenterGroupConnection',
  CommandCenterGroupStatus: 'CommandCenterGroupStatus',
  CommandCenterSignalLabelStatus: 'CommandCenterSignalLabelStatus',
  CommandCenterSloRef: 'CommandCenterSloRef',
  Comment: 'Comment',
  CommentSearchConnection: 'CommentSearchConnection',
  CommentSearchResult: 'CommentSearchResult',
  CommentsConnection: 'CommentsConnection',
  Component: 'Component',
  ComponentDashboardPresentationConfig: 'ComponentDashboardPresentationConfig',
  ComponentDiscovery: 'ComponentDiscovery',
  ComponentDiscoveryConfig: 'ComponentDiscoveryConfig',
  ComponentDiscoveryOverride: 'ComponentDiscoveryOverride',
  ComponentEventPresentationConfig: 'ComponentEventPresentationConfig',
  ComponentPresentationConfig: 'ComponentPresentationConfig',
  ComponentPresentationOverride: 'ComponentPresentationOverride',
  ConditionOverride: 'ConditionOverride',
  ConfigEntity: 'ConfigEntity',
  ConstructedLabel: 'ConstructedLabel',
  ConsumptionBudget: 'ConsumptionBudget',
  ConsumptionBudgetAlertActionConfig: 'ConsumptionBudgetAlertActionConfig',
  ConsumptionBudgetFilter: 'ConsumptionBudgetFilter',
  ConsumptionBudgetInstantRate: 'ConsumptionBudgetInstantRate',
  ConsumptionBudgetPriority: 'ConsumptionBudgetPriority',
  ConsumptionBudgetThreshold: 'ConsumptionBudgetThreshold',
  ConsumptionBudgetVolume: 'ConsumptionBudgetVolume',
  ConsumptionConfigDefaultPartition: 'ConsumptionConfigDefaultPartition',
  ConsumptionConfigMetricFilter: 'ConsumptionConfigMetricFilter',
  ConsumptionConfigPartition: 'ConsumptionConfigPartition',
  ConsumptionConfigPartitionFilter: 'ConsumptionConfigPartitionFilter',
  ConsumptionConfigPartitionFilterCondition: 'ConsumptionConfigPartitionFilterCondition',
  ConsumptionContract: 'ConsumptionContract',
  ConsumptionCreditsByResolution: 'ConsumptionCreditsByResolution',
  ConsumptionPartition: 'ConsumptionPartition',
  ConsumptionPartitionFilter: 'ConsumptionPartitionFilter',
  ConsumptionPartitionFilterCondition: 'ConsumptionPartitionFilterCondition',
  ConsumptionProductSpec: 'ConsumptionProductSpec',
  ConsumptionProducts: 'ConsumptionProducts',
  ConsumptionSkuGroupSpec: 'ConsumptionSkuGroupSpec',
  ConsumptionSkuPrice: 'ConsumptionSkuPrice',
  ConsumptionSkuSpec: 'ConsumptionSkuSpec',
  ContainerHealth: 'ContainerHealth',
  ContainerInfo: 'ContainerInfo',
  ContainerLifecycle: 'ContainerLifecycle',
  ContainerResources: 'ContainerResources',
  CountFilter: 'CountFilter',
  CrashEvent: 'CrashEvent',
  CrashEventEvidence: 'CrashEventEvidence',
  CreatePersonalAccessTokenResponse: 'CreatePersonalAccessTokenResponse',
  CreateServiceAccountResponse: 'CreateServiceAccountResponse',
  CustomComponentOutput: 'CustomComponentOutput',
  Dashboard: 'Dashboard',
  DashboardLabel: 'DashboardLabel',
  DashboardsConnection: 'DashboardsConnection',
  Dataset: 'Dataset',
  DatasetConnection: 'DatasetConnection',
  DeaggregateResult: 'DeaggregateResult',
  DeaggregatedQuery: 'DeaggregatedQuery',
  DebugLog: 'DebugLog',
  DebugLogEntry: 'DebugLogEntry',
  DefaultResourcePool: 'DefaultResourcePool',
  DefaultSampleRate: 'DefaultSampleRate',
  DeleteSyntheticGlobalVariableResult: 'DeleteSyntheticGlobalVariableResult',
  DeploymentEvent: 'DeploymentEvent',
  DeploymentEvidence: 'DeploymentEvidence',
  DeploymentInfo: 'DeploymentInfo',
  DerivedLabel: 'DerivedLabel',
  DerivedLabelFilter: 'DerivedLabelFilter',
  DerivedLabelPreview: 'DerivedLabelPreview',
  DerivedLabelSpanTag: 'DerivedLabelSpanTag',
  DerivedLabelSpanTagNameMapping: 'DerivedLabelSpanTagNameMapping',
  DerivedLabelValueMapping: 'DerivedLabelValueMapping',
  DescriptionData: 'DescriptionData',
  DiscoveredComponent: 'DiscoveredComponent',
  DiscoveredService: 'DiscoveredService',
  DiscoveryPipelineStatusMessage: 'DiscoveryPipelineStatusMessage',
  DocArtifact: 'DocArtifact',
  DocArtifactConnection: 'DocArtifactConnection',
  Downtime: 'Downtime',
  DropRule: 'DropRule',
  DropRuleValueBasedDrop: 'DropRuleValueBasedDrop',
  DropValue: 'DropValue',
  DurationFilter: 'DurationFilter',
  EligibleServicesConnection: 'EligibleServicesConnection',
  EmitMetricsCounter: 'EmitMetricsCounter',
  EmitMetricsGauge: 'EmitMetricsGauge',
  EmitMetricsHistogram: 'EmitMetricsHistogram',
  EmitMetricsLabel: 'EmitMetricsLabel',
  EntityVersion: 'EntityVersion',
  EntityVersionsConnection: 'EntityVersionsConnection',
  ErrorCodeDef: 'ErrorCodeDef',
  EventDiscovery: 'EventDiscovery',
  EventLog: 'EventLog',
  EventLogListItem: 'EventLogListItem',
  EventLogs: 'EventLogs',
  ExportConfigQuery: 'ExportConfigQuery',
  ExportedConfig: 'ExportedConfig',
  ExternalConnection: 'ExternalConnection',
  ExternalConnectionCloudflareConfig: 'ExternalConnectionCloudflareConfig',
  ExternalConnectionHTTPBasicAuth: 'ExternalConnectionHTTPBasicAuth',
  ExternalConnectionHTTPConfig: 'ExternalConnectionHTTPConfig',
  ExternalConnectionHTTPTLSConfig: 'ExternalConnectionHTTPTLSConfig',
  ExternalConnectionOpsGenieConfig: 'ExternalConnectionOpsGenieConfig',
  ExternalConnectionPagerDutyConfig: 'ExternalConnectionPagerDutyConfig',
  ExternalConnectionPagerDutyEventsConfig: 'ExternalConnectionPagerDutyEventsConfig',
  ExternalConnectionSlackConfig: 'ExternalConnectionSlackConfig',
  ExternalConnectionVictorOpsConfig: 'ExternalConnectionVictorOpsConfig',
  ExternalConnectionWebhookConfig: 'ExternalConnectionWebhookConfig',
  ExternalConnectionsConnection: 'ExternalConnectionsConnection',
  FeatureFlag: 'FeatureFlag',
  FieldNormalization: 'FieldNormalization',
  FilterQueryValidationResult: 'FilterQueryValidationResult',
  GatewayConfigs: 'GatewayConfigs',
  GeneratedDescription: 'GeneratedDescription',
  GrafanaDashboard: 'GrafanaDashboard',
  GrafanaDashboardsConnection: 'GrafanaDashboardsConnection',
  GraphiteLabelPolicy: 'GraphiteLabelPolicy',
  GraphiteLabelPolicyReplace: 'GraphiteLabelPolicyReplace',
  GrokParser: 'GrokParser',
  ImageChange: 'ImageChange',
  ImageChangeEvent: 'ImageChangeEvent',
  IntValue: 'IntValue',
  IntegrationMetadata: 'IntegrationMetadata',
  Investigation: 'Investigation',
  InvestigationAlertContext: 'InvestigationAlertContext',
  InvestigationContext: 'InvestigationContext',
  InvestigationResolvedService: 'InvestigationResolvedService',
  InvestigationsConnection: 'InvestigationsConnection',
  JaegerRemotePerOperationSamplingStrategies: 'JaegerRemotePerOperationSamplingStrategies',
  JaegerRemotePerOperationSamplingStrategy: 'JaegerRemotePerOperationSamplingStrategy',
  JaegerRemoteSamplingProbabilisticStrategy: 'JaegerRemoteSamplingProbabilisticStrategy',
  JaegerRemoteSamplingRateLimitingSamplingStrategy: 'JaegerRemoteSamplingRateLimitingSamplingStrategy',
  K8sContextDiscoveryResult: 'K8sContextDiscoveryResult',
  K8sEventInference: 'K8sEventInference',
  K8sSearchCriteria: 'K8sSearchCriteria',
  KeyValueParser: 'KeyValueParser',
  KnownMetric: 'KnownMetric',
  Label: 'Label',
  LabelConfig: 'LabelConfig',
  LabelMapping: 'LabelMapping',
  LabelMatcher: 'LabelMatcher',
  LabelNames: 'LabelNames',
  LabelPair: 'LabelPair',
  LabelPolicy: 'LabelPolicy',
  LabelValues: 'LabelValues',
  Link: 'Link',
  LinkTemplate: 'LinkTemplate',
  ListDerivedLabelsConnection: 'ListDerivedLabelsConnection',
  LogControlConfig: 'LogControlConfig',
  LogControlRule: 'LogControlRule',
  LogControlRuleDropField: 'LogControlRuleDropField',
  LogControlRuleEmitMetrics: 'LogControlRuleEmitMetrics',
  LogControlRuleParseField: 'LogControlRuleParseField',
  LogControlRuleReplaceField: 'LogControlRuleReplaceField',
  LogControlRuleSample: 'LogControlRuleSample',
  LogDatasetConfiguration: 'LogDatasetConfiguration',
  LogFieldParser: 'LogFieldParser',
  LogFieldPath: 'LogFieldPath',
  LogIngestConfig: 'LogIngestConfig',
  LogLookupTable: 'LogLookupTable',
  LogParser: 'LogParser',
  LogRetentionConfig: 'LogRetentionConfig',
  LogRetentionConfigLongTermRetention: 'LogRetentionConfigLongTermRetention',
  LogSearchFilter: 'LogSearchFilter',
  LoggingContract: 'LoggingContract',
  LoggingLimit: 'LoggingLimit',
  ManagedBy: 'ManagedBy',
  MappingLabel: 'MappingLabel',
  MappingRule: 'MappingRule',
  MappingRuleAggregationPolicy: 'MappingRuleAggregationPolicy',
  MatchingMonitorRoutesAndConditions: 'MatchingMonitorRoutesAndConditions',
  MetricDDXResult: 'MetricDDXResult',
  MetricDiscovery: 'MetricDiscovery',
  MetricDiscoveryMetadata: 'MetricDiscoveryMetadata',
  MetricDiscoveryOverride: 'MetricDiscoveryOverride',
  MetricDiscoveryTarget: 'MetricDiscoveryTarget',
  MetricLabel: 'MetricLabel',
  MetricMetadata: 'MetricMetadata',
  MetricMetadataConnection: 'MetricMetadataConnection',
  MetricSettings: 'MetricSettings',
  Monitor: 'Monitor',
  MonitorCondition: 'MonitorCondition',
  MonitorMuted: 'MonitorMuted',
  MonitorNotificationPolicy: 'MonitorNotificationPolicy',
  MonitorQuery: 'MonitorQuery',
  MonitorResolvedAlertEvent: 'MonitorResolvedAlertEvent',
  MonitorResolvedNotificationFailedToSend: 'MonitorResolvedNotificationFailedToSend',
  MonitorResolvedNotificationSent: 'MonitorResolvedNotificationSent',
  MonitorSeries: 'MonitorSeries',
  MonitorSignal: 'MonitorSignal',
  MonitorSignalConfig: 'MonitorSignalConfig',
  MonitorSpec: 'MonitorSpec',
  MonitorState: 'MonitorState',
  MonitorStats: 'MonitorStats',
  MonitorSummary: 'MonitorSummary',
  MonitorTriggeredAlertEvent: 'MonitorTriggeredAlertEvent',
  MonitorTriggeredNotificationFailedToSend: 'MonitorTriggeredNotificationFailedToSend',
  MonitorTriggeredNotificationSent: 'MonitorTriggeredNotificationSent',
  MonitorTypeConsumptionBudget: 'MonitorTypeConsumptionBudget',
  MonitorTypeDefault: 'MonitorTypeDefault',
  MonitorUnmuted: 'MonitorUnmuted',
  MonitorsConnection: 'MonitorsConnection',
  Mutation: 'Mutation',
  MutingRule: 'MutingRule',
  MutingRuleConnection: 'MutingRuleConnection',
  MutingRulesForMonitor: 'MutingRulesForMonitor',
  NameMapping: 'NameMapping',
  NameMappingValues: 'NameMappingValues',
  NamedStringNormalization: 'NamedStringNormalization',
  NodeInfo: 'NodeInfo',
  Notebook: 'Notebook',
  NotebooksConnection: 'NotebooksConnection',
  NotificationPolicy: 'NotificationPolicy',
  NotificationPolicyConnection: 'NotificationPolicyConnection',
  NotificationPolicyDestination: 'NotificationPolicyDestination',
  NotificationPolicyDestinationEmailTarget: 'NotificationPolicyDestinationEmailTarget',
  NotificationPolicyDestinationOpsgenieTarget: 'NotificationPolicyDestinationOpsgenieTarget',
  NotificationPolicyDestinationPagerdutyTarget: 'NotificationPolicyDestinationPagerdutyTarget',
  NotificationPolicyDestinationSlackTarget: 'NotificationPolicyDestinationSlackTarget',
  NotificationPolicyDestinationVictoropsTarget: 'NotificationPolicyDestinationVictoropsTarget',
  NotificationPolicyDestinationWebhookQueryParameter: 'NotificationPolicyDestinationWebhookQueryParameter',
  NotificationPolicyDestinationWebhookTarget: 'NotificationPolicyDestinationWebhookTarget',
  NotificationPolicyDestinationsBySeverity: 'NotificationPolicyDestinationsBySeverity',
  NotificationRoutes: 'NotificationRoutes',
  NotificationRoutesOverride: 'NotificationRoutesOverride',
  NotificationRule: 'NotificationRule',
  Notifier: 'Notifier',
  NotifiersBySeverity: 'NotifiersBySeverity',
  NumericFilter: 'NumericFilter',
  ObjectDiscoveryMetricRule: 'ObjectDiscoveryMetricRule',
  ObjectDiscoveryRule: 'ObjectDiscoveryRule',
  ObjectMergeRule: 'ObjectMergeRule',
  OemLoggingConfig: 'OemLoggingConfig',
  PageInfo: 'PageInfo',
  Panel: 'Panel',
  PanelAnnotationLabelName: 'PanelAnnotationLabelName',
  PanelAnnotationLabelValue: 'PanelAnnotationLabelValue',
  PanelQuery: 'PanelQuery',
  PersonalAccessToken: 'PersonalAccessToken',
  PlaintextParser: 'PlaintextParser',
  PodInfo: 'PodInfo',
  PresentationComponent: 'PresentationComponent',
  PresentationEligibility: 'PresentationEligibility',
  ProbeStatus: 'ProbeStatus',
  PromQL: 'PromQL',
  Query: 'Query',
  RPC: 'RPC',
  RateLimit: 'RateLimit',
  RecordingRule: 'RecordingRule',
  RecordingRuleLabel: 'RecordingRuleLabel',
  RecordingRules: 'RecordingRules',
  RegexParser: 'RegexParser',
  RelativeTimeFilter: 'RelativeTimeFilter',
  ReplaceFieldMappedValue: 'ReplaceFieldMappedValue',
  ReplaceFieldMappedValuePair: 'ReplaceFieldMappedValuePair',
  ReplaceFieldStaticValue: 'ReplaceFieldStaticValue',
  ReplacementInfo: 'ReplacementInfo',
  ReplicaCountChange: 'ReplicaCountChange',
  ResourcePool: 'ResourcePool',
  ResourcePoolAllocation: 'ResourcePoolAllocation',
  ResourcePoolAllocationFixedValue: 'ResourcePoolAllocationFixedValue',
  ResourcePoolAllocationThreshold: 'ResourcePoolAllocationThreshold',
  ResourcePoolAllocationThresholds: 'ResourcePoolAllocationThresholds',
  ResourcePoolHighLowPriorities: 'ResourcePoolHighLowPriorities',
  ResourcePools: 'ResourcePools',
  RestartEvent: 'RestartEvent',
  Result: 'Result',
  RetentionPolicy: 'RetentionPolicy',
  Role: 'Role',
  RollupRule: 'RollupRule',
  RollupRuleLabelReplace: 'RollupRuleLabelReplace',
  RuleEvaluation: 'RuleEvaluation',
  RuleEvaluations: 'RuleEvaluations',
  SLI: 'SLI',
  SLIEndpointAvailability: 'SLIEndpointAvailability',
  SLIEndpointLatency: 'SLIEndpointLatency',
  SLIMetadata: 'SLIMetadata',
  SLIQueries: 'SLIQueries',
  SLITemplateData: 'SLITemplateData',
  SLITimesliceCondition: 'SLITimesliceCondition',
  SLITimesliceQueries: 'SLITimesliceQueries',
  SLO: 'SLO',
  SLOBurnRateDefinition: 'SLOBurnRateDefinition',
  SLOCalculatedBurnRate: 'SLOCalculatedBurnRate',
  SLOConnection: 'SLOConnection',
  SLODefinition: 'SLODefinition',
  SLOErrorCode: 'SLOErrorCode',
  SLOMetadataEndpointAvailability: 'SLOMetadataEndpointAvailability',
  SLOMetadataLatency: 'SLOMetadataLatency',
  SLORelatedMetricsQueries: 'SLORelatedMetricsQueries',
  SLOReportingWindow: 'SLOReportingWindow',
  SavedTraceSearch: 'SavedTraceSearch',
  SavedTraceSearchConnection: 'SavedTraceSearchConnection',
  ScalingEvent: 'ScalingEvent',
  Schedule: 'Schedule',
  ScheduleDay: 'ScheduleDay',
  ScopeFilter: 'ScopeFilter',
  SearchConnection: 'SearchConnection',
  SearchHistoryConnection: 'SearchHistoryConnection',
  SearchHistoryQuery: 'SearchHistoryQuery',
  SeriesConditions: 'SeriesConditions',
  Service: 'Service',
  ServiceAccount: 'ServiceAccount',
  ServiceAccountLabel: 'ServiceAccountLabel',
  ServiceAttribute: 'ServiceAttribute',
  ServiceComponentViewDetails: 'ServiceComponentViewDetails',
  ServiceDiscoveryOutput: 'ServiceDiscoveryOutput',
  ServiceInfo: 'ServiceInfo',
  ServiceStatuses: 'ServiceStatuses',
  ServiceToTracingServiceAttributeMap: 'ServiceToTracingServiceAttributeMap',
  ServiceView: 'ServiceView',
  ServicesConnection: 'ServicesConnection',
  Settings: 'Settings',
  SeverityCondition: 'SeverityCondition',
  ShortenedMessage: 'ShortenedMessage',
  SignalGrouping: 'SignalGrouping',
  SignedURL: 'SignedURL',
  SignupInvite: 'SignupInvite',
  SpanFilter: 'SpanFilter',
  StaticList: 'StaticList',
  StoragePolicy: 'StoragePolicy',
  StringFilter: 'StringFilter',
  StringNormalization: 'StringNormalization',
  StringValue: 'StringValue',
  SuppressionMergeRule: 'SuppressionMergeRule',
  SyntheticGlobalVariable: 'SyntheticGlobalVariable',
  SyntheticGlobalVariableTestReference: 'SyntheticGlobalVariableTestReference',
  SyntheticTest: 'SyntheticTest',
  SyntheticTestHttpTestConfig: 'SyntheticTestHttpTestConfig',
  SyntheticTestStatusCodeAssertion: 'SyntheticTestStatusCodeAssertion',
  TagFilter: 'TagFilter',
  Target: 'Target',
  Team: 'Team',
  TeamBulkUpdate: 'TeamBulkUpdate',
  TeamHomepage: 'TeamHomepage',
  TeamsForUserBulkUpdate: 'TeamsForUserBulkUpdate',
  Template: 'Template',
  TemplateValue: 'TemplateValue',
  Tenant: 'Tenant',
  TenantConfiguration: 'TenantConfiguration',
  TenantSettings: 'TenantSettings',
  TestFieldParserResult: 'TestFieldParserResult',
  TestParserResult: 'TestParserResult',
  Thread: 'Thread',
  ThreadsConnection: 'ThreadsConnection',
  TimeRange: 'TimeRange',
  TimeWindow: 'TimeWindow',
  TimelineCategory: 'TimelineCategory',
  TimestampNormalization: 'TimestampNormalization',
  TraceActiveBehaviorsConnection: 'TraceActiveBehaviorsConnection',
  TraceAggregationFocus: 'TraceAggregationFocus',
  TraceAggregationGroupByKey: 'TraceAggregationGroupByKey',
  TraceAggregationOptions: 'TraceAggregationOptions',
  TraceAggregationShape: 'TraceAggregationShape',
  TraceBehavior: 'TraceBehavior',
  TraceBehaviorActiveAssignment: 'TraceBehaviorActiveAssignment',
  TraceBehaviorConfig: 'TraceBehaviorConfig',
  TraceBehaviorErrorSampleOptions: 'TraceBehaviorErrorSampleOptions',
  TraceBehaviorFastSampleOptions: 'TraceBehaviorFastSampleOptions',
  TraceBehaviorLargeTraceSampleOptions: 'TraceBehaviorLargeTraceSampleOptions',
  TraceBehaviorMainAssignment: 'TraceBehaviorMainAssignment',
  TraceBehaviorOverrideAssignment: 'TraceBehaviorOverrideAssignment',
  TraceBehaviorSlowSampleOptions: 'TraceBehaviorSlowSampleOptions',
  TraceBehaviorSmallTraceSampleOptions: 'TraceBehaviorSmallTraceSampleOptions',
  TraceBehaviorsConnection: 'TraceBehaviorsConnection',
  TraceDatasetConfiguration: 'TraceDatasetConfiguration',
  TraceDatasetEnhancement: 'TraceDatasetEnhancement',
  TraceDiscovery: 'TraceDiscovery',
  TraceFilter: 'TraceFilter',
  TraceJaegerRemoteSamplingStrategy: 'TraceJaegerRemoteSamplingStrategy',
  TraceJaegerRemoteSamplingStrategyConnection: 'TraceJaegerRemoteSamplingStrategyConnection',
  TraceMetricsGroupBy: 'TraceMetricsGroupBy',
  TraceMetricsGroupByKey: 'TraceMetricsGroupByKey',
  TraceMetricsRule: 'TraceMetricsRule',
  TraceMetricsRulesConnection: 'TraceMetricsRulesConnection',
  TraceSearch: 'TraceSearch',
  TraceSearchFilter: 'TraceSearchFilter',
  TraceSearchHistory: 'TraceSearchHistory',
  TraceSearchHistoryConnection: 'TraceSearchHistoryConnection',
  TraceTailSamplingRule: 'TraceTailSamplingRule',
  TraceTailSamplingRules: 'TraceTailSamplingRules',
  TraceTopTag: 'TraceTopTag',
  TraceTopTags: 'TraceTopTags',
  TracingLicenseLimits: 'TracingLicenseLimits',
  TracingServiceAttributeToServiceMap: 'TracingServiceAttributeToServiceMap',
  TracingServiceMapping: 'TracingServiceMapping',
  Transform: 'Transform',
  UsageStatsConfig: 'UsageStatsConfig',
  User: 'User',
  UserSearchHistory: 'UserSearchHistory',
  UserSettings: 'UserSettings',
  ValidationResult: 'ValidationResult',
  ValueDefinition: 'ValueDefinition',
  ValueMapping: 'ValueMapping',
  XRayNodes: 'XRayNodes',
  XRayResult: 'XRayResult',
  eventFilter: 'eventFilter',
  eventFilters: 'eventFilters',
};

export type TypenamesContext = Required<Pick<OperationContext, 'additionalTypenames'>>;

export const GetCurrentUserContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetFeatureFlagsV2Context: TypenamesContext = {
  additionalTypenames: ['FeatureFlag'],
};

export const GetGatewayConfigsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ServiceOverviewContext: TypenamesContext = {
  additionalTypenames: ['LabelConfig', 'ValueMapping', 'Component'],
};

export const ListMonitorsQueryContext: TypenamesContext = {
  additionalTypenames: ['Monitor', 'MonitorSignal', 'MonitorSeries', 'Label'],
};
